(function() {
  'use strict';
  
  const PRODUCTION_MODE = false;
  let productCache = {};
  let setGroups = new Map();
  let isUpdating = false;
  const SHOW_SET_DETAILS = false;

  // Beden sirasi - kucukten buyuge (XS, S, M, L, XL, XXL... veya sayisal: 80, 85, 90)
  const SIZE_ORDER_CART = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL','6XL'];
  function sizeRankCart(s) {
    const up = String(s).toUpperCase().trim();
    const idx = SIZE_ORDER_CART.indexOf(up);
    if (idx !== -1) return idx;
    const num = parseFloat(up);
    if (!isNaN(num)) return 1000 + num;
    return 99999;
  }

  // ============================================
  // WEIGHT CALCULATOR - Cart Weight Integration
  // ============================================
  const weightCache = {};

  /**
   * Parse weight from product description HTML
   * Looks for: <span class="product-weight-data" data-weight="250" data-unit="g">
   */
  function parseWeightFromDescription(description) {
    if (!description) return null;

    // Try to find the hidden weight data span
    const match = description.match(/data-weight="([\d.]+)"\s*data-unit="(\w+)"/);
    if (match) {
      log('Weight data found:', match[1], match[2]);
      return {
        weight: parseFloat(match[1]),
        unit: match[2].toLowerCase()
      };
    }

    // Fallback: try to parse from visible text "Ağırlık: 250g"
    const textMatch = description.match(/Ağırlık:<\/strong>\s*([\d.]+)\s*(g|kg|gr)/i);
    if (textMatch) {
      log('Weight from text found:', textMatch[1], textMatch[2]);
      return {
        weight: parseFloat(textMatch[1]),
        unit: textMatch[2].toLowerCase() === 'kg' ? 'kg' : 'g'
      };
    }

    return null;
  }

  /**
   * Convert weight to grams for calculation
   */
  function toGrams(weight, unit) {
    if (unit === 'kg') {
      return weight * 1000;
    }
    return weight; // already in grams
  }

  /**
   * Format weight for display
   */
  function formatWeight(grams) {
    if (grams >= 1000) {
      return (grams / 1000).toFixed(2).replace(/\.?0+$/, '') + 'kg';
    }
    return Math.round(grams) + 'g';
  }

  /**
   * Fetch product weight by handle
   */
  async function fetchProductWeight(handle) {
    // Check cache first
    if (weightCache[handle] !== undefined) {
      return weightCache[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.json`);
      if (!response.ok) {
        weightCache[handle] = null;
        return null;
      }

      const data = await response.json();
      const description = data.product?.body_html || '';
      const weightInfo = parseWeightFromDescription(description);

      log('Fetched weight for', handle, ':', weightInfo);
      weightCache[handle] = weightInfo;
      return weightInfo;
    } catch (error) {
      log('Error fetching weight for', handle, error);
      weightCache[handle] = null;
      return null;
    }
  }
  // ============================================
  // END WEIGHT CALCULATOR
  // ============================================
  
  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Cart Set]', ...args);
    }
  }
  
  function logError(...args) {
    console.error('[Set Multiplier Error]', ...args);
  }
  
  // quantity-multiplier.js ile uyumlu parse fonksiyonu
  function parseCompleteSetInfo(description, productTitle) {
    if (!description) return null;

    let cleanText = description.toString().trim();
    cleanText = cleanText.replace(/<[^>]*>/g, '');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, '');
    cleanText = cleanText.replace(/^\*+/g, '');
    cleanText = cleanText.replace(/\*+$/g, '');
    cleanText = cleanText.replace(/\*/g, '');
    cleanText = cleanText.replace(/[\r\n\t\f\v]/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');
    cleanText = cleanText.trim();

    log('Parsing description:', cleanText);

    // ✅ KAT SAYI: İç giyim için Kat Sayı kontrolü
    const katSayiMatch = cleanText.match(/Kat Sayı:\s*(\d+)/);
    if (katSayiMatch) {
      const katSayi = parseInt(katSayiMatch[1]);
      if (katSayi > 0) {
        log('Kat Sayı formatı bulundu:', katSayi);
        return {
          type: 'kat_sayi',
          multiplier: katSayi,
          isMultiSize: false,
          isKatSayi: true
        };
      }
    }

    // 1. SET İÇERİK BİLGİSİ FORMATI - quantity-multiplier.js mantığı
    let setContent = null;

    // **Set İçerik Bilgisi:** formatı
    if (cleanText.includes('Set İçerik Bilgisi:')) {
      const parts = cleanText.split('Set İçerik Bilgisi:');
      if (parts.length > 1) {
        const endMarkers = ['Teknik', 'Kumaş', 'Kalıp', 'Kol', 'Beden', 'Bakım', 'Ürün', 'Barkod'];
        let content = parts[1];
        for (const marker of endMarkers) {
          if (content.includes(marker)) {
            content = content.split(marker)[0];
            break;
          }
        }
        setContent = content.trim();
      }
    }
    
    // Set İçeriği: formatı
    if (!setContent && cleanText.includes('Set İçeriği:')) {
      const parts = cleanText.split('Set İçeriği:');
      if (parts.length > 1) {
        setContent = parts[1].split(/Teknik|Kumaş|Barkod/)[0].trim();
      }
    }
    
    // Dağılım: formatı
    if (!setContent && cleanText.includes('Dağılım:')) {
      const parts = cleanText.split('Dağılım:');
      if (parts.length > 1) {
        setContent = parts[1].split(/Teknik|Kumaş|Barkod/)[0].trim();
      }
    }
    
    // Set içeriğini parse et - güncellenmiş mantık
    if (setContent) {
      const distribution = parseBedenAdetCiftleri(setContent)
        || parseSetDistribution(setContent);
      
      if (Object.keys(distribution).length > 0) {
        log('Multi-size set bulundu:', distribution);
        return {
          type: 'multi_size_set',
          distribution: distribution,
          isMultiSize: true
        };
      }
    }
    
    // 2. STD FORMATI
    const stdMatch = cleanText.match(/STD\s*[-:]\s*(\d+)/);
    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log('STD formatı:', multiplier);
      return {
        type: 'std',
        multiplier: multiplier,
        isMultiSize: false
      };
    }
    
    // 3. ÜRÜN ADINDAN SET BİLGİSİ
    if (productTitle) {
      const titleUpper = productTitle.toUpperCase();
      const setPatterns = [
        /(\d+)\s*[''']?\s*[Ll][İIıi]\s*[Ss][Ee][Tt]/,
        /(\d+)\s*[Aa][Dd][Ee][Tt]/,
        /(\d+)\s*[Ll][İIıi]\s*[Pp][Aa][Kk][Ee][Tt]/
      ];
      
      for (const pattern of setPatterns) {
        const match = titleUpper.match(pattern);
        if (match) {
          const multiplier = parseInt(match[1]);
          if (multiplier > 1) {
            return {
              type: 'title_based',
              multiplier: multiplier,
              isMultiSize: false
            };
          }
        }
      }
    }
    
    return null;
  }
  /** '85=2|90=2|95=1|100=1' -> { '85':2, '90':2, '95':1, '100':1 }
   *  Sayisal bedenlerde eski parser calismadigi icin bu bicim once denenir. */
function parseBedenAdetCiftleri(text) {
  if (!text) return null;
  const dagilim = {};
  let sayi = 0;
  // Son cifti olcu tablosu metni izleyebilir (ornek: "XXL=1 Olcu Tablosu (cm) ..."),
  // bu yuzden parcanin tamami degil basi eslestirilir; cift olmayan ilk parcada durulur.
  for (const par of String(text).split('|')) {
    const k = par.trim().match(/^([^=\s|]+)\s*=\s*(\d+)(?!\d)/);
    if (!k || parseInt(k[2], 10) <= 0) break;
    dagilim[k[1]] = parseInt(k[2], 10);
    sayi++;
  }
  return sayi >= 2 ? dagilim : null;
}

  // ✅ YENİ: Set İçeriği formatı için özel parser
function parseSetIcerigiFormat(distributionText) {
  if (!distributionText) return {};

  const distribution = {};
  let text = distributionText.toString().trim();

  // Set İçeriği formatı için özel temizleme
  text = text.replace(/<[^>]*>/g, ' '); // HTML tags'leri boşlukla değiştir
  text = text.replace(/&[a-zA-Z0-9#]+;/g, ' ');
  text = text.replace(/[\r\n\t\f\v]/g, ' ');
  text = text.replace(/\s+/g, ' ');
  text = text.trim();

  log('Parsing Set İçeriği format:', text);

  // Set İçeriği formatına özel invalid words
  const invalidWords = new Set(['ÖLÇÜ', 'TABLOSU', 'CM', 'BOYUT', 'GENİŞLİĞİ', 'UZUNLUĞU', 'DÜŞÜKLÜĞÜ', 'WIDTH', 'LENGTH', 'DROP', 'CHEST', 'BACK', 'SLEEVE', 'NECK', 'SHOULDER']);

  // İlk önce invalid kelimelerden sonrasını kes
  for (const invalidWord of invalidWords) {
    if (text.toUpperCase().includes(invalidWord)) {
      const parts = text.toUpperCase().split(invalidWord);
      text = parts[0].trim();
      break;
    }
  }

  log('Cleaned text for Set İçeriği:', text);

  // Bilinen bedenler (uzundan kısaya sıralı)
  const knownSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];

  // ✅ KZK FORMAT: S-M=1|L-XL=1|7-8 Yas=2 (her seyi destekler, en oncelikli)
  if (text.includes('=') && text.includes('|')) {
    const kzkPairs = text.split('|').map(s => s.trim()).filter(Boolean);
    let kzkMatched = false;
    for (const pair of kzkPairs) {
      const eqIdx = pair.lastIndexOf('=');
      if (eqIdx > 0) {
        const size = pair.substring(0, eqIdx).trim().toUpperCase();
        const qty = parseInt(pair.substring(eqIdx + 1).trim(), 10);
        if (size && !isNaN(qty) && qty > 0) {
          distribution[size] = qty;
          kzkMatched = true;
          log(`Added KZK item: ${size} = ${qty}`);
        }
      }
    }
    if (kzkMatched && Object.keys(distribution).length > 0) {
      return distribution;
    }
  }

  // ✅ YENİ FORMAT: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
  // Pattern: (opsiyonel numara + harf beden) + tire + adet
  const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
  if (hyphenatedMatches.length > 0) {
    log(`Found hyphenated format matches (L-2, XL-4...): ${hyphenatedMatches.length}`);

    for (const match of hyphenatedMatches) {
      const size = match[1].toUpperCase();
      const quantity = match[2];

      // Geçerli beden olduğundan emin ol
      const isValidSize = knownSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
      const q = parseInt(quantity, 10);
      if (isValidSize && !isNaN(q) && q > 0) {
        distribution[size] = q;
        log(`Added hyphenated item: ${size} = ${q}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      return distribution;
    }
  }

  // ✅ YENİ FORMAT: 1XL1-2XL1-3XL1-4XL1 (BedenNumara formatı)
  const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/gi)];
  if (complexMatches.length > 0) {
    log(`Found complex format matches (1XL1...): ${complexMatches.length}`);

    for (const match of complexMatches) {
      const fullSizeName = match[1] + match[2].toUpperCase();
      const quantity = parseInt(match[3], 10);
      if (!isNaN(quantity) && quantity > 0) {
        distribution[fullSizeName] = quantity;
        log(`Added complex item: ${fullSizeName} = ${quantity}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      return distribution;
    }
  }

  // ✅ YENİ FORMAT: S1-M1-L1-XL1 (Standart beden+adet bitişik)
  const escapedSizes = knownSizes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const sizePattern = new RegExp(`(${escapedSizes.join('|')})(\\d+)`, 'gi');
  const standardMatches = [...text.matchAll(sizePattern)];
  if (standardMatches.length > 0) {
    log(`Found standard format matches (S1-M1...): ${standardMatches.length}`);

    for (const match of standardMatches) {
      const size = match[1].toUpperCase();
      const quantity = parseInt(match[2], 10);
      if (!isNaN(quantity) && quantity > 0) {
        distribution[size] = quantity;
        log(`Added standard item: ${size} = ${quantity}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      return distribution;
    }
  }

  // Set İçeriği formatına özel pattern: digit-digit-digit formatı
  const setIcerigiMatches = [...text.matchAll(/(\d+-\d+)-(\d+)/g)];

  if (setIcerigiMatches.length > 0) {
    log(`Found Set İçeriği format matches: ${setIcerigiMatches.length}`);

    for (const match of setIcerigiMatches) {
      const sizeRange = match[1]; // "7-8", "9-10", etc.
      const quantity = match[2];   // "1", "1", etc.

      const q = parseInt(quantity, 10);
      if (!isNaN(q) && q > 0) {
        distribution[sizeRange] = q;
        log(`Added Set İçeriği item: ${sizeRange} = ${q}`);
      }
    }

    return distribution;
  }

  // Eğer digit-digit-digit formatı bulunamazsa, boşlukla ayrılmış aralıkları dene
  const spaceMatches = [...text.matchAll(/(\d+-\d+)/g)];
  if (spaceMatches.length > 0) {
    log(`Found space-separated ranges: ${spaceMatches.length}`);

    for (const match of spaceMatches) {
      const sizeRange = match[1];
      distribution[sizeRange] = 1; // Default quantity
      log(`Added space-separated range: ${sizeRange} = 1`);
    }

    return distribution;
  }

  log('No Set İçeriği format matches found');
  return {};
}
  // parseSetDistribution - quantity-multiplier.js ile aynı mantık + YENİ FORMATLAR
  function parseSetDistribution(distributionText) {
    if (!distributionText) return {};
    
    const distribution = {};
    let text = distributionText.toString().trim();
     if (text.includes('Set İçeriği:') || /\d+-\d+-\d+/.test(text)) {
    log('Detected Set İçeriği format, using special parser');
    const setIcerigiResult = parseSetIcerigiFormat(text);
    if (Object.keys(setIcerigiResult).length > 0) {
      return setIcerigiResult;
    }
    log('Set İçeriği parser failed, continuing with normal parsing');
  }
    // HTML ve özel karakterleri temizle
    text = text.replace(/<[^>]*>/g, '');
    text = text.replace(/&[a-zA-Z0-9#]+;/g, '');
    text = text.replace(/[*]/g, '');
    text = text.replace(/[\r\n\t\f\v]/g, ' ');
    text = text.replace(/\s+/g, ' ');
    text = text.trim();
    
    log('Parsing distribution text:', text);
    
    const invalid = new Set(['TRY','USD','EUR','GBP','ADET','KG','TL','CM','MM','PIECE']);
    
    const addToDistribution = (size, qty) => {
      const s = String(size).toUpperCase().trim();
      const q = parseInt(qty, 10);
      if (!s || isNaN(q) || q <= 0 || invalid.has(s)) return false;
      
      // Eğer bu beden zaten eklenmiş ise, sadece miktarı güncelle (toplamayı değil)
      if (distribution[s]) {
        log(`Size ${s} already exists with quantity ${distribution[s]}, skipping duplicate`);
        return false;
      }
      
      distribution[s] = q;
      log(`Added to distribution: ${s} = ${q}`);
      return true;
    };
    
    let matched = false;
    
    // ✅ YENİ FORMAT 1: Beden aralığı + miktar (3-4-1, 5-6-1, 7-8-2)
    // Daha kesin pattern: kelime sınırları ve boşluk kontrolü ile
    const rangeWithQuantityMatches = [...text.matchAll(/(?:^|\s)(\d+-\d+)-(\d+)(?=\s|$)/g)];
    if (rangeWithQuantityMatches.length > 0) {
      log(`Found range+quantity format matches: ${rangeWithQuantityMatches.length}`);
      
      for (const match of rangeWithQuantityMatches) {
        const sizeRange = match[1]; // "3-4", "5-6", "7-8"
        const quantity = match[2];   // "1", "1", "2"
        
        log(`Processing range+quantity: ${sizeRange} -> ${quantity}`);
        if (addToDistribution(sizeRange, quantity)) {
          matched = true;
        }
      }
    }
    
    // ✅ YENİ FORMAT 2: Sadece beden aralığı (9-10, 11-12, 13-14) - miktar 1 varsayılır
    if (!matched) {
      // Daha kesin pattern: sadece "sayı-sayı" formatı, etrafında boşluk olmalı
      const rangeOnlyMatches = [...text.matchAll(/(?:^|\s)(\d+-\d+)(?=\s|$)/g)];
      if (rangeOnlyMatches.length > 0) {
        log(`Found range-only format matches: ${rangeOnlyMatches.length}`);
        
        for (const match of rangeOnlyMatches) {
          const sizeRange = match[1]; // "9-10", "11-12", "13-14"
          
          log(`Processing range-only: ${sizeRange} -> 1`);
          if (addToDistribution(sizeRange, 1)) {
            matched = true;
          }
        }
      }
    }
    
    // FORMAT 3: 1XL1-2XL2-3XL1-4XL1 (BedenNumara formatı) - sadece önceki formatlar başarısız olursa
    if (!matched) {
      const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/g)];
      if (complexMatches.length > 0) {
        log(`Found complex format matches: ${complexMatches.length}`);
        
        for (const match of complexMatches) {
          const prefix = match[1]; // İlk rakam (beden numarası)
          const sizeBase = match[2]; // Beden harfleri (XL, L, vb.)
          const quantity = match[3]; // Adet
          
          // Tam beden adını oluştur (1XL, 2XL, vb.)
          const fullSizeName = prefix + sizeBase;
          
          if (addToDistribution(fullSizeName, quantity)) {
            matched = true;
          }
        }
      }
    }
    
    // FORMAT 4: XL1-L2-M1 (Standart beden+adet formatı) - sadece önceki formatlar başarısız olursa
    if (!matched) {
      // Tipik beden formatlarını kontrol et
      const knownSizesPattern = /([0-9]*[A-Z]{1,4})(\d+)/g;
      const sizeMatches = [...text.matchAll(knownSizesPattern)];
      
      for (const match of sizeMatches) {
        const size = match[1];
        const quantity = match[2];
        
        // Geçerli beden formatı kontrol et
        if (/^(XXS|XS|S|M|L|XL|XXL|XXXL|\d*XL|\d*L|2XS|3XL|4XL)$/i.test(size)) {
          if (addToDistribution(size, quantity)) {
            matched = true;
          }
        }
      }
    }
    
    // FORMAT 5: S-M-L-XL (Adet belirtilmemiş, her bedenden 1'er adet) - sadece önceki formatlar başarısız olursa
    if (!matched) {
      // Tire ile ayrılmış formatı kontrol et
      const dashSeparated = text.split(/[-\s,|\/]+/).filter(part => {
        const cleaned = part.trim().toUpperCase();
        return cleaned.length > 0 && 
               !invalid.has(cleaned) && 
               /^[A-Z0-9]+$/.test(cleaned) &&
               !(/^\d+$/.test(cleaned) && cleaned.length > 2); // Sadece sayı olan uzun değerleri hariç tut
      });
      
      if (dashSeparated.length > 1) {
        for (const part of dashSeparated) {
          const cleanPart = part.trim().toUpperCase();
          
          // Tipik beden formatındaysa
          if (/^(XXS|XS|S|M|L|XL|XXL|XXXL|\d+XL|\d+L|2XS|3XL|4XL)$/i.test(cleanPart)) {
            if (addToDistribution(cleanPart, 1)) {
              matched = true;
            }
          }
        }
      }
    }
    
    // FORMAT 6: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
    if (!matched) {
      const knownSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];
      const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
      if (hyphenatedMatches.length > 0) {
        log(`Found hyphenated format matches (L-2, XL-4...): ${hyphenatedMatches.length}`);
        for (const match of hyphenatedMatches) {
          const size = match[1].toUpperCase();
          const quantity = match[2];
          const isValidSize = knownSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
          if (isValidSize && !invalid.has(size) && addToDistribution(size, quantity)) {
            matched = true;
          }
        }
      }
    }

    // FORMAT 7: Alternatif format arama - S:2, M:1 gibi kolon formatı - sadece önceki formatlar başarısız olursa
    if (!matched) {
      const colonMatches = [...text.matchAll(/([A-Z0-9]{1,4})\s*:\s*(\d+)/gi)];

      for (const match of colonMatches) {
        const size = match[1].toUpperCase();
        const quantity = match[2];

        if (!invalid.has(size) && addToDistribution(size, quantity)) {
          matched = true;
        }
      }
    }
    
    log('Final distribution:', distribution);
    return distribution;
  }
  
  // Ürün bilgilerini al
  async function getProductSetInfo(handle) {
    // Retail ürünleri (-r suffix) set olarak işleme, ayrı satırda kalsın
    if (handle && handle.endsWith('-r')) {
      log(`Retail ürün tespit edildi, set olarak işlenmeyecek: ${handle}`);
      return null;
    }

    if (productCache[handle]) {
      return productCache[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      
      const product = await response.json();
      const setInfo = parseCompleteSetInfo(product.description, product.title);
      
      if (setInfo) {
        setInfo.handle = handle;
        setInfo.productId = product.id;
        setInfo.title = product.title;
        setInfo.variants = product.variants;
        
        productCache[handle] = setInfo;
        log(`Set bilgisi (${handle}):`, setInfo);
      }
      
      return setInfo;
    } catch (error) {
      log('Ürün bilgisi alınamadı:', error);
      return null;
    }
  }

  // ✅ YENİ: Renk bilgisini tespit et
  function extractColorFromVariant(item) {
    const variantTitle = item.variant_title || item.title || '';
    const optionsArray = item.options_with_values || [];
    
    // Option'lar içinden color'ı bul
    for (const option of optionsArray) {
      const optionName = (option.name || '').toLowerCase();
      if (optionName.includes('color') || optionName.includes('colour') || 
          optionName.includes('renk') || optionName === 'renk') {
        return option.value || variantTitle.split('/')[0].trim();
      }
    }
    
    // Variant title'dan renk çıkarma dene
    const titleParts = variantTitle.split('/').map(p => p.trim());
    if (titleParts.length > 1) {
      return titleParts[0]; // İlk kısım genelde renk
    }
    
    return 'default'; // Fallback
  }

  // ✅ KZK: Beden ismini variant'tan cikar
  function extractSizeFromVariant(item) {
    const optionsArray = item.options_with_values || [];
    for (const option of optionsArray) {
      const optionName = (option.name || '').toLowerCase();
      if (optionName.includes('size') || optionName.includes('beden') || optionName.includes('boyut')) {
        return (option.value || '').toUpperCase().trim();
      }
    }
    const variantTitle = item.variant_title || item.title || '';
    const parts = variantTitle.split('/').map(p => p.trim());
    if (parts.length > 1) return parts[parts.length - 1].toUpperCase();
    return variantTitle.toUpperCase().trim();
  }

  // ✅ GÜNCELLENDİ: Set'leri renk ile grupla
  async function groupSetItems() {
    const cart = await fetch('/cart.js').then(r => r.json());
    setGroups.clear();

    // ✅ KZK AUTO-GROUP: handle+renk bazinda on-gruplama
    // Set bilgisi olmasa da ayni urun+renk olan birden fazla beden tek satirda grupanir
    const handleColorMap = new Map();
    for (const item of cart.items) {
      const h = item.handle || item.url?.split('/products/')[1]?.split('?')[0];
      if (!h || h.endsWith('-r')) continue;
      const c = extractColorFromVariant(item);
      const k = `${h}_${c}`;
      if (!handleColorMap.has(k)) handleColorMap.set(k, []);
      handleColorMap.get(k).push(item);
    }

    for (const item of cart.items) {
      const handle = item.handle || item.url?.split('/products/')[1]?.split('?')[0];
      if (!handle) continue;

      let setInfo = await getProductSetInfo(handle);

      // ✅ KZK FALLBACK: set bilgisi yoksa ama ayni handle+renk olan birden fazla variant varsa virtual set
      if (!setInfo) {
        const color = extractColorFromVariant(item);
        const groupItems = handleColorMap.get(`${handle}_${color}`) || [];
        if (groupItems.length > 1) {
          const distribution = {};
          for (const it of groupItems) {
            const sz = extractSizeFromVariant(it);
            if (sz) distribution[sz] = 1;
          }
          if (Object.keys(distribution).length > 1) {
            setInfo = {
              type: 'auto_grouped',
              distribution,
              isMultiSize: true,
              isAutoGrouped: true,
              handle,
              title: item.product_title || ''
            };
            log(`Auto-group olusturuldu: ${handle}_${color}`, distribution);
          }
        }
      }

      if (!setInfo) continue;
      
      // ✅ YENİ: Renk bilgisini al
      const itemColor = extractColorFromVariant(item);
      const groupKey = `${handle}_${itemColor}`;
      
      log(`Processing item: ${handle}, color: ${itemColor}, groupKey: ${groupKey}`);
      
      // Multi-size set için gruplama
      if (setInfo.isMultiSize) {
        if (!setGroups.has(groupKey)) {
          setGroups.set(groupKey, {
            info: setInfo,
            items: [],
            distribution: setInfo.distribution || {},
            color: itemColor,
            handle: handle
          });
        }
        
        const group = setGroups.get(groupKey);
        
        // Hangi bedene ait olduğunu bul
        const variantTitle = item.variant_title || item.title || '';
        let sizeKey = null;
        const upTitle = (item.variant_title || '').toUpperCase().trim();

        // 1) Tam eşleşme (en güvenlisi)
        const keys = Object.keys(setInfo.distribution || {});
        const sortedKeys = keys.slice().sort((a,b) => b.length - a.length); // XXL önce, XL sonra

        sizeKey = sortedKeys.find(k => upTitle === k)
               || sortedKeys.find(k => upTitle.split('/').map(s => s.trim()).includes(k));

        // 2) Yine de bulunamazsa: kelime sınırıyla güvenli regex
        if (!sizeKey) {
          for (const k of sortedKeys) {
            const re = new RegExp(`(?:^|[^A-Z0-9])${k}(?:$|[^A-Z0-9])`);
            if (re.test(upTitle)) { sizeKey = k; break; }
          }
        }
        
        // ✅ YENİ: Beden aralığı eşleşmesi (9-10, 11-12 gibi)
        if (!sizeKey) {
          for (const k of sortedKeys) {
            if (/^\d+-\d+$/.test(k)) {
              const rangeParts = k.split('-');
              const start = parseInt(rangeParts[0]);
              const end = parseInt(rangeParts[1]);
              
              // Variant title'daki sayıları kontrol et
              const titleNumbers = upTitle.match(/\d+/g);
              if (titleNumbers) {
                for (const numStr of titleNumbers) {
                  const num = parseInt(numStr);
                  if (num >= start && num <= end) {
                    sizeKey = k;
                    break;
                  }
                }
              }
              if (sizeKey) break;
            }
          }
        }
        
        if (sizeKey) {
          const expectedQty = setInfo.distribution[sizeKey] || 1;
          group.items.push({
            ...item,
            size: sizeKey,
            expectedQty,
            key: item.key,
            variantId: item.variant_id || item.id
          });
        }
      } else {
        // Tek varyantlı set ürünler
        if (!setGroups.has(groupKey)) {
          setGroups.set(groupKey, {
            info: setInfo,
            items: [item],
            multiplier: setInfo.multiplier || 1,
            color: itemColor,
            handle: handle
          });
        }
      }
    }
    
    log('Renk bazında set grupları oluşturuldu:', setGroups);
    return setGroups;
  }
  
  // ✅ GÜNCELLENDİ: Multi-size set'i renk bazında güncelle
  async function updateMultiSizeSet(groupKey, operation) {
    const group = setGroups.get(groupKey);
    if (!group || !group.info.isMultiSize) return;
    
    const updates = {};
    
    // Mevcut set sayısını hesapla
    let currentSets = Infinity;
    for (const item of group.items) {
      const itemSets = Math.floor(item.quantity / item.expectedQty);
      currentSets = Math.min(currentSets, itemSets);
    }
    
    if (currentSets === Infinity || currentSets < 0) currentSets = 0;
    
    // Yeni set sayısını hesapla
    let newSets;
    if (operation === 'increase') {
      newSets = currentSets + 1;
    } else if (operation === 'decrease') {
      newSets = Math.max(0, currentSets - 1);
    } else if (typeof operation === 'number') {
      newSets = Math.max(0, operation);
    } else {
      newSets = currentSets;
    }
    
    log(`Set güncelleme (${group.color}): ${currentSets} -> ${newSets} set`);
    
    // Her beden için yeni miktarı hesapla
    for (const item of group.items) {
      const newQty = newSets * item.expectedQty;
      updates[item.key] = newQty;
      log(`${item.size} (${group.color}): ${item.quantity} → ${newQty} (${item.expectedQty} x ${newSets} set)`);
    }
    
    // Eksik bedenleri kontrol et ve ekle (auto-group'larda eklem yapma)
    if (newSets > 0 && group.info.distribution && !group.info.isAutoGrouped) {
      await addMissingVariants(group.handle, group, newSets);
    }
    
    // Toplu güncelleme yap
    await batchUpdateCart(updates);
    
    // Bildirim göster
    const changeText = operation === 'increase' ? '+1 set' : 
                      operation === 'decrease' ? '-1 set' : 
                      `${newSets} set`;
    
    const itemsText = Object.entries(group.info.distribution).map(([size, baseQty]) => 
      `${size}: ${baseQty * newSets}`
    ).join(', ');
    
    showNotification(`${group.info.title} (${group.color}): ${changeText} (${itemsText})`, 'success');
  }
  
  // ✅ GÜNCELLENDİ: Eksik varyantları eklerken renk filtrelemesi + Beden aralığı desteği
  async function addMissingVariants(handle, group, sets) {
    if (sets === 0) return;
    
    const existingSizes = group.items.map(item => item.size);
    const missingSizes = Object.keys(group.info.distribution).filter(size => !existingSizes.includes(size));
    
    if (missingSizes.length === 0) return;
    
    log('Eksik bedenler bulundu:', missingSizes);
    
    try {
      const product = await fetch(`/products/${handle}.js`).then(r => r.json());
      
      for (const size of missingSizes) {
        // ✅ YENİ: Beden aralığı formatını kontrol et
        const isRangeFormat = /^\d+-\d+$/.test(size);
        
        // İlgili varyantı bul - renk filtresi ile + beden aralığı desteği
        const variant = product.variants.find(v => {
          // Renk kontrolü
          const variantTitle = v.title || '';
          const titleParts = variantTitle.split('/').map(p => p.trim());
          const variantColor = titleParts.length > 1 ? titleParts[0] : 'default';
          
          if (variantColor !== group.color && group.color !== 'default') {
            return false;
          }
          
          // Size kontrolü
          const title = (v.title || '').toUpperCase();
          const option1 = (v.option1 || '').toUpperCase();
          const option2 = (v.option2 || '').toUpperCase();
          const option3 = (v.option3 || '').toUpperCase();
          
          if (isRangeFormat) {
            // ✅ YENİ: Beden aralığı için özel mantık
            const rangeParts = size.split('-');
            const startSize = rangeParts[0];
            const endSize = rangeParts[1];
            
            return [title, option1, option2, option3].some(opt => {
              // Tam sayı bedenleri için aralık kontrolü
              if (/^\d+$/.test(startSize) && /^\d+$/.test(endSize)) {
                const start = parseInt(startSize);
                const end = parseInt(endSize);
                const optNum = parseInt(opt);
                if (!isNaN(optNum) && optNum >= start && optNum <= end) {
                  return true;
                }
              }
              // Direk string eşleşmesi de kontrol et
              return opt.includes(startSize) || opt.includes(endSize) || opt === size.toUpperCase();
            });
          } else {
            // Normal beden eşleşmesi
            return title.includes(size) || option1 === size || option2 === size || option3 === size;
          }
        });
        
        if (variant && variant.available) {
          const qty = group.info.distribution[size] * sets;
          
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variant.id,
              quantity: qty
            })
          });
          
          log(`Eksik beden eklendi: ${size} (${group.color}) - ${qty} adet`);
        }
      }
      
      // Grupları yenile
      await groupSetItems();
    } catch (error) {
      log('Eksik varyant ekleme hatası:', error);
    }
  }
  
  // Toplu sepet güncellemesi
  async function batchUpdateCart(updates) {
    if (Object.keys(updates).length === 0) return;
    
    isUpdating = true;
    
    try {
      const formData = new FormData();
      for (const [key, qty] of Object.entries(updates)) {
        formData.append(`updates[${key}]`, qty);
      }
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        await refreshCart();
      }
    } catch (error) {
      log('Toplu güncelleme hatası:', error);
    } finally {
      isUpdating = false;
    }
  }
  
  // ✅ YENİ: DOM element'inden cart item key'ini çıkar
  function getItemKeyFromDom(domItem) {
    // 1. data-key attribute
    if (domItem.dataset?.key) {
      return domItem.dataset.key;
    }

    // 2. data-cart-item-key attribute
    if (domItem.dataset?.cartItemKey) {
      return domItem.dataset.cartItemKey;
    }

    // 3. Input name'den çıkar: updates[KEY]
    const input = domItem.querySelector('input[name*="updates"]');
    if (input) {
      const match = input.name.match(/updates\[([^\]]+)\]/);
      if (match) return match[1];
    }

    // 4. Remove button'dan çıkar
    const removeBtn = domItem.querySelector('a[href*="/cart/change"]');
    if (removeBtn) {
      const href = removeBtn.getAttribute('href');
      const match = href.match(/id=([^&]+)/);
      if (match) return match[1];
    }

    // 5. data-line attribute (1-indexed line number)
    const line = domItem.dataset?.line || domItem.dataset?.index;
    if (line) {
      return `line_${line}`;
    }

    // 6. Herhangi bir child'da key ara
    const keyElement = domItem.querySelector('[data-key], [data-cart-item-key]');
    if (keyElement) {
      return keyElement.dataset.key || keyElement.dataset.cartItemKey;
    }

    return null;
  }

  // ✅ YENİ: Set ürünlerini tek satırda grupla - HANDLE + RENK BAZINDA
  function collapseSetItems(cartItems) {
    const processedGroups = new Set();
    const itemsByGroup = new Map();

    // DOM item'larını handle + renk bazında grupla
    for (const domItem of cartItems) {
      const handle = getHandleFromItem(domItem);
      if (!handle) continue;

      // Bu item'ın rengini al
      const itemColor = extractColorFromItem(domItem);
      const groupKey = `${handle}_${itemColor}`;

      // Bu groupKey için setGroups'ta bir grup var mı kontrol et
      const group = setGroups.get(groupKey);
      if (!group || !group.info.isMultiSize) continue;

      if (!itemsByGroup.has(groupKey)) {
        itemsByGroup.set(groupKey, { items: [], group: group });
      }
      itemsByGroup.get(groupKey).items.push(domItem);
    }

    log('Handle+Renk bazında gruplar:', itemsByGroup.size);

    // Her grup için işlem yap
    for (const [groupKey, data] of itemsByGroup) {
      const { items, group } = data;

      if (items.length <= 1) {
        // Tek item olsa bile set bilgisi badge'i ve fiyat güncelle
        if (items.length === 1) {
          const singleItem = items[0];
          singleItem.classList.add('set-master-item');

          // ✅ Inline flex stil uygula - CSS override garantisi
          singleItem.style.display = 'flex';
          singleItem.style.flexDirection = 'row';
          singleItem.style.flexWrap = 'nowrap';
          singleItem.style.alignItems = 'flex-start';
          singleItem.style.gap = '15px';

          // Görsel container'ı düzelt
          const thumbContainer = singleItem.querySelector('.wt-cart__item__thumb, .cart-item__image, picture');
          if (thumbContainer) {
            thumbContainer.style.flex = '0 0 auto';
            thumbContainer.style.width = '100px';
            thumbContainer.style.maxWidth = '100px';
          }

          // Body container'ı düzelt
          const bodyContainer = singleItem.querySelector('.wt-cart__item__body, .cart-item__details');
          if (bodyContainer) {
            bodyContainer.style.flex = '1 1 auto';
            bodyContainer.style.minWidth = '0';
          }

          addSetInfoBadge(singleItem, group);
          hideSizeOption(singleItem);
          updateSetTotalPrice(singleItem, group);
        }
        log(`${groupKey}: Tek item, gruplama gerekmez`);
        continue;
      }

      log(`Set gruplama: ${groupKey}, ${items.length} satır -> 1 satır`);

      // İlk item'ı master olarak belirle
      const masterItem = items[0];
      masterItem.classList.add('set-master-item');
      masterItem.dataset.setGroupKey = groupKey;

      // ✅ Inline flex stil uygula - CSS override garantisi
      masterItem.style.display = 'flex';
      masterItem.style.flexDirection = 'row';
      masterItem.style.flexWrap = 'nowrap';
      masterItem.style.alignItems = 'flex-start';
      masterItem.style.gap = '15px';

      // Görsel container'ı düzelt
      const thumbContainer = masterItem.querySelector('.wt-cart__item__thumb, .cart-item__image, picture');
      if (thumbContainer) {
        thumbContainer.style.flex = '0 0 auto';
        thumbContainer.style.width = '100px';
        thumbContainer.style.maxWidth = '100px';
      }

      // Body container'ı düzelt
      const bodyContainer = masterItem.querySelector('.wt-cart__item__body, .cart-item__details');
      if (bodyContainer) {
        bodyContainer.style.flex = '1 1 auto';
        bodyContainer.style.minWidth = '0';
      }

      // Set bilgisi badge'i ekle (options'un içine)
      addSetInfoBadge(masterItem, group);

      // Beden seçeneğini gizle (set bilgisinde zaten var)
      hideSizeOption(masterItem);

      // ✅ Toplam fiyatı güncelle (tüm bedenler dahil)
      updateSetTotalPrice(masterItem, group);

      // Diğer item'ları gizle
      for (let i = 1; i < items.length; i++) {
        const itemToHide = items[i];

        // Gizle
        itemToHide.style.cssText = 'display: none !important;';
        itemToHide.classList.add('set-hidden-item');
        itemToHide.dataset.setGroupKey = groupKey;
        itemToHide.setAttribute('aria-hidden', 'true');

        // ✅ KZK: Set koruma - hidden item'larin tum etkilesim elemanlarini disable et
        // Plus/Minus butonlari, quantity input ve remove button'i disable
        itemToHide.querySelectorAll('button, input, a').forEach(el => {
          if (el.tagName === 'A') {
            el.setAttribute('aria-disabled', 'true');
            el.style.pointerEvents = 'none';
            el.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); }, { capture: true });
          } else {
            el.disabled = true;
            el.setAttribute('tabindex', '-1');
          }
        });

        // Parent li/div elementini de gizle (bazı temalarda gerekli)
        const parentLi = itemToHide.closest('li');
        if (parentLi && parentLi !== masterItem.closest('li')) {
          parentLi.style.cssText = 'display: none !important;';
          parentLi.classList.add('set-hidden-item');
        }

        log(`Gizlendi: ${i}. item (set koruma aktif)`, itemToHide);
      }

      processedGroups.add(groupKey);
    }

    return processedGroups;
  }

  // Urun sayfasinin HTML'ini fetch et, wholesale-data.liquid'in window.productData'sindan
  // inventory_quantity dolu variants array'ini cek. /products/{handle}.js inventory dondurmuyor.
  async function fetchVariantsWithInventory(handle) {
    try {
      const res = await fetch(`/products/${handle}`);
      if (!res.ok) return null;
      const html = await res.text();

      // 1. Once variant-options script[type="application/json"] (cogu Dawn-style temada)
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const voScript = doc.querySelector('variant-options script[type="application/json"]');
      if (voScript) {
        try {
          const data = JSON.parse(voScript.textContent);
          if (Array.isArray(data) && data.length && data[0].inventory_quantity != null) {
            return data;
          }
        } catch (e) { /* fallthrough */ }
      }

      // 2. wholesale-data.liquid: window.productData = {...variants:[...inventory_quantity:N...]...}
      const wdMatch = html.match(/window\.productData\s*=\s*\{[\s\S]*?\bvariants:\s*(\[[\s\S]*?\])\s*,\s*\n?\s*options:/);
      if (wdMatch) {
        try {
          const variants = eval('(' + wdMatch[1] + ')');
          if (Array.isArray(variants)) return variants;
        } catch (e) { /* skip */ }
      }
      return null;
    } catch (e) {
      console.warn('[cart-set] fetchVariantsWithInventory failed:', e);
      return null;
    }
  }

  // ✅ Stok bazli max set hesabi: her bedenin variant'ina gore floor(stock/distQty)'nin minimum'u
  async function calculateMaxSets(handle, distribution, color) {
    const variants = await fetchVariantsWithInventory(handle);
    if (!variants) return null;

    let minSets = Infinity;
    const sizes = Object.keys(distribution);

    for (const size of sizes) {
      const distQty = parseInt(distribution[size]) || 1;
      const matches = variants.filter(v => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(s => String(s).toUpperCase());
        if (!opts.includes(String(size).toUpperCase())) return false;
        if (color && color !== 'default') {
          return opts.includes(String(color).toUpperCase());
        }
        return true;
      });

      if (!matches.length) continue;

      let totalStock = 0;
      for (const v of matches) {
        // inventory_quantity null ise atla (gercek stok bilinmiyor, yanlis 999 vermeyelim)
        if (typeof v.inventory_quantity !== 'number') continue;
        totalStock += Math.max(0, v.inventory_quantity);
      }

      const setsForThisSize = Math.floor(totalStock / distQty);
      if (setsForThisSize < minSets) minSets = setsForThisSize;
    }

    return minSets === Infinity ? null : minSets;
  }

  // ✅ YENİ: Set bilgisi badge'i ekle - Basit ve net
  async function addSetInfoBadge(item, group) {
    // Varsa eski badge'leri kaldır
    const existingBadge = item.querySelector('.set-info-badge');
    if (existingBadge) existingBadge.remove();
    const existingMaxBadge = item.querySelector('.set-max-badge');
    if (existingMaxBadge) existingMaxBadge.remove();
    const existingWeightBadge = item.querySelector('.weight-info-badge');
    if (existingWeightBadge) existingWeightBadge.remove();

    // Set içindeki beden sayısı
    const sizesInSet = Object.keys(group.info.distribution).length;

    // Set sayısını hesapla
    const setCount = group.info.isMultiSize
      ? Math.min(...group.items.map(i => Math.floor(i.quantity / (i.expectedQty || 1))))
      : group.items[0]?.quantity || 1;

    // Toplam adet = set içindeki adet × set sayısı
    let itemsPerSet = 0;
    for (const qty of Object.values(group.info.distribution)) {
      itemsPerSet += qty;
    }
    const totalQuantity = itemsPerSet * setCount;

    // Beden dağılımı (kucukten buyuge sirali: M:1 L:2 XL:1)
    const sizeDistribution = Object.entries(group.info.distribution)
      .sort((a, b) => sizeRankCart(a[0]) - sizeRankCart(b[0]))
      .map(([size, qty]) => `${size}:${qty}`)
      .join(' ');

    // Set badge - Turkce
    const setBadge = document.createElement('div');
    setBadge.className = 'product-option set-info-badge';
    setBadge.innerHTML = `
      <span class="label">Set:</span>
      <span class="value">${itemsPerSet} adet × ${setCount} set = <strong>${totalQuantity} adet</strong> (${sizeDistribution})</span>
    `;

    // Barcode option'ından sonra ekle
    const optionsDiv = item.querySelector('.options');
    if (optionsDiv) {
      const barcodeOption = Array.from(optionsDiv.querySelectorAll('.product-option'))
        .find(opt => opt.textContent.toLowerCase().includes('barcode'));

      if (barcodeOption) {
        barcodeOption.insertAdjacentElement('afterend', setBadge);
      } else {
        optionsDiv.appendChild(setBadge);
      }
    } else {
      const dataDiv = item.querySelector('.wt-cart__item__data, .cart-item__details');
      if (dataDiv) {
        dataDiv.appendChild(setBadge);
      }
    }

    // ✅ Maksimum eklenebilir set (stok bazli)
    // Set urununde tek beden yaniltici duruyor: "Beden: XXL" -> "Beden: Set"
    if (group.info.isMultiSize) {
      item.querySelectorAll('.cart-item__variants dt').forEach(dt => {
        if (!/^\s*(beden|size)\s*:/i.test(dt.textContent || '')) return;
        const dd = dt.nextElementSibling;
        if (dd && dd.tagName === 'DD') dd.textContent = 'Set';
      });
    }

    const maxSets = await calculateMaxSets(group.handle, group.info.distribution, group.color);
    if (maxSets != null) {
      const maxBadge = document.createElement('div');
      maxBadge.className = 'product-option set-max-badge';
      maxBadge.innerHTML = `
        <span class="label">Maksimum eklenebilir:</span>
        <span class="value"><strong>${maxSets} set</strong></span>
      `;
      setBadge.insertAdjacentElement('afterend', maxBadge);
    }

    // ✅ Weight badge ekle
    await addWeightBadge(item, group.handle, totalQuantity);
  }

  // ✅ Weight badge ekle - Set badge'in hemen altına
  async function addWeightBadge(item, handle, totalQuantity) {
    try {
      const weightInfo = await fetchProductWeight(handle);
      if (!weightInfo || !weightInfo.weight) {
        log('No weight info for', handle);
        return 0;
      }

      const unitWeightGrams = toGrams(weightInfo.weight, weightInfo.unit);
      const totalWeightGrams = unitWeightGrams * totalQuantity;

      log('Weight calculated:', handle, unitWeightGrams, 'g ×', totalQuantity, '=', totalWeightGrams, 'g');

      // Weight badge elementi oluştur
      const weightBadge = document.createElement('div');
      weightBadge.className = 'product-option weight-info-badge';

      if (totalQuantity > 1) {
        weightBadge.innerHTML = `
          <span class="label">Ağırlık:</span>
          <span class="value">${formatWeight(unitWeightGrams)} × ${totalQuantity} adet = <strong>${formatWeight(totalWeightGrams)}</strong></span>
        `;
      } else {
        weightBadge.innerHTML = `
          <span class="label">Ağırlık:</span>
          <span class="value"><strong>${formatWeight(totalWeightGrams)}</strong></span>
        `;
      }

      // Set badge'in hemen altına ekle
      const setBadge = item.querySelector('.set-info-badge');
      if (setBadge) {
        setBadge.insertAdjacentElement('afterend', weightBadge);
      } else {
        const optionsDiv = item.querySelector('.options');
        if (optionsDiv) {
          optionsDiv.appendChild(weightBadge);
        }
      }

      return totalWeightGrams;
    } catch (error) {
      log('Error adding weight badge:', error);
      return 0;
    }
  }

  // ✅ YENİ: Beden seçeneğini gizle
  function hideSizeOption(item) {
    const optionsDiv = item.querySelector('.options');
    if (!optionsDiv) return;

    const allOptions = optionsDiv.querySelectorAll('.product-option');
    for (const opt of allOptions) {
      const label = opt.querySelector('.label');
      if (label) {
        const labelText = label.textContent.toLowerCase();
        if (labelText.includes('size') || labelText.includes('beden')) {
          opt.style.display = 'none';
          log('Beden seçeneği gizlendi');
          break;
        }
      }
    }
  }

  // ✅ YENİ: Gruplanmış set özet bilgisini ekle
  function addCollapsedSetSummary(masterItem, group, allItems) {
    // Varsa eski özeti kaldır
    const existingSummary = masterItem.querySelector('.set-collapsed-summary');
    if (existingSummary) existingSummary.remove();

    // Set sayısını hesapla
    const currentSets = Math.min(
      ...group.items.map(i => Math.floor(i.quantity / i.expectedQty))
    );

    // Toplam adet ve fiyat hesapla
    let totalQuantity = 0;
    let totalPrice = 0;

    for (const item of group.items) {
      totalQuantity += item.quantity;
      totalPrice += (item.price || 0) * item.quantity;
    }

    // Dağılım bilgisi
    const distributionText = Object.entries(group.info.distribution)
      .map(([size, qty]) => `${size}: ${qty * currentSets}`)
      .join(' • ');

    // Özet HTML - Minimal tasarım
    const summary = document.createElement('div');
    summary.className = 'set-collapsed-summary';
    summary.style.cssText = `
      background: #f8f9fa;
      color: #333;
      padding: 8px 12px;
      border-radius: 6px;
      margin: 6px 0;
      font-size: 12px;
      border: 1px solid #e9ecef;
    `;

    summary.innerHTML = `
      <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
        <span style="font-weight: 500;">${currentSets} Set</span>
        ${group.color !== 'default' ? `<span style="opacity: 0.7;">(${group.color})</span>` : ''}
        <span style="opacity: 0.5;">•</span>
        <span style="opacity: 0.8; font-size: 11px;">${distributionText}</span>
        <span style="opacity: 0.5;">•</span>
        <span style="opacity: 0.6; font-size: 11px;">${totalQuantity} adet</span>
      </div>
    `;

    // Ürün bilgisi bölümünden sonra ekle
    const productInfo = masterItem.querySelector('.cart-item__details, .wt-cart__item-details, .product-info, .item-info');
    if (productInfo) {
      productInfo.appendChild(summary);
    } else {
      // Fallback: İlk uygun yere ekle
      const firstChild = masterItem.querySelector('.cart-item__content, .wt-cart__item-content');
      if (firstChild) {
        firstChild.appendChild(summary);
      } else {
        masterItem.appendChild(summary);
      }
    }

    // Orijinal varyant bilgisini gizle/güncelle
    const variantInfo = masterItem.querySelector('.product-option, .variant-info, .cart-item__variant');
    if (variantInfo) {
      variantInfo.style.display = 'none';
    }

    // ✅ YENİ: Toplam fiyatı güncelle (tüm bedenler dahil)
    updateSetTotalPrice(masterItem, group);
  }

  // ✅ GÜNCELLENDİ: Set toplam fiyatını güncelle - TÜM BEDENLER DAHİL
  function updateSetTotalPrice(masterItem, group) {
    // Toplam fiyatı hesapla (tüm bedenler dahil)
    let totalPrice = 0;
    let totalQuantity = 0;

    log('Set fiyat hesaplama başlıyor:', group.handle);

    for (const item of group.items) {
      const itemPrice = item.price || 0;
      const itemQty = item.quantity || 0;
      const itemTotal = itemPrice * itemQty;

      totalPrice += itemTotal;
      totalQuantity += itemQty;

      log(`  - ${item.size}: ${itemQty} adet x ${(itemPrice/100).toFixed(2)} = ${(itemTotal/100).toFixed(2)}`);
    }

    log(`Toplam: ${totalQuantity} adet, ${(totalPrice/100).toFixed(2)} fiyat`);

    // Fiyat elementini bul - önce data attribute ile, sonra class ile
    const priceWrapper = masterItem.querySelector('.wt-cart__item__price-wrapper');
    let priceEl = null;

    if (priceWrapper) {
      // Önce data-line-price attribute ile ara
      priceEl = priceWrapper.querySelector('[data-line-price]');

      // Bulunamazsa .price.price--end ile ara
      if (!priceEl) {
        priceEl = priceWrapper.querySelector('.price.price--end:not(.cart-item__old-price)');
      }

      // Hala bulunamazsa herhangi bir .price elementi
      if (!priceEl) {
        priceEl = priceWrapper.querySelector('.price:not(.cart-item__old-price):not(s)');
      }
    }

    // Son çare: genel selector
    if (!priceEl) {
      priceEl = masterItem.querySelector('[data-line-price], .price.price--end, .cart-item__price, .cart-item__total');
    }

    if (priceEl) {
      // Para birimi formatını al
      const originalText = priceEl.textContent || '';

      // Para birimini tespit et (başta veya sonda olabilir)
      let currency = '$';
      let currencyAtEnd = false;

      // Yaygın para birimleri
      if (originalText.includes('₺') || originalText.includes('TL')) {
        currency = '₺';
        currencyAtEnd = originalText.indexOf('₺') > originalText.search(/\d/);
      } else if (originalText.includes('€')) {
        currency = '€';
        currencyAtEnd = originalText.indexOf('€') > originalText.search(/\d/);
      } else if (originalText.includes('£')) {
        currency = '£';
      } else if (originalText.includes('$')) {
        currency = '$';
      }

      // Fiyatı formatla
      const formattedPrice = (totalPrice / 100).toFixed(2);

      // Orijinal fiyatı sakla
      if (!priceEl.dataset.originalPrice) {
        priceEl.dataset.originalPrice = originalText;
      }

      // Yeni fiyatı göster (para birimi konumu korunarak)
      const newPriceText = currencyAtEnd
        ? `${formattedPrice}${currency}`
        : `${currency}${formattedPrice}`;

      priceEl.textContent = newPriceText;
      priceEl.dataset.setTotalPrice = 'true';
      priceEl.dataset.setTotalQty = totalQuantity;

      log(`✅ Fiyat güncellendi: ${originalText} -> ${newPriceText} (${totalQuantity} adet toplam)`);
    } else {
      log(`⚠️ Fiyat elementi bulunamadı, masterItem:`, masterItem);
    }
  }

  // ✅ YENİ: Master item'ın quantity gösterimini güncelle
  function updateMasterQuantityDisplay(masterItem, group) {
    const currentSets = Math.min(
      ...group.items.map(i => Math.floor(i.quantity / i.expectedQty))
    );

    // Quantity input'u bul ve set sayısını göster
    const quantityInput = masterItem.querySelector('input[name*="updates"], input.quantity__input, input[type="number"]');
    if (quantityInput) {
      // Set sayısını göster (orijinal değeri sakla)
      quantityInput.dataset.originalValue = quantityInput.value;
      quantityInput.dataset.isSetMaster = 'true';

      // Quantity wrapper'ı bul
      const quantityWrapper = quantityInput.closest('.quantity, .quantity-selector, .cart-item__quantity');
      if (quantityWrapper) {
        // Set etiketi ekle
        let setLabel = quantityWrapper.querySelector('.set-quantity-label');
        if (!setLabel) {
          setLabel = document.createElement('div');
          setLabel.className = 'set-quantity-label';
          setLabel.style.cssText = `
            font-size: 11px;
            color: #667eea;
            font-weight: 600;
            text-align: center;
            margin-top: 4px;
          `;
          quantityWrapper.appendChild(setLabel);
        }
        setLabel.textContent = `${currentSets} Set`;
      }
    }
  }

  // Sepet sayfası kontrollerini ayarla
  async function setupCartPageControls() {
    if (!window.location.pathname.includes('/cart')) return;

    await groupSetItems();

    // Farklı tema yapılarını destekle
    const cartItemSelectors = [
      '[data-cart-item]',
      '.cart-item',
      '.cart__item',
      'tr[data-product-id]',
      '.cart-item__row',
      '.cart__row',
      '[data-key]',
      '.wt-cart__item'
    ];

    const cartItems = document.querySelectorAll(cartItemSelectors.join(', '));
    log(`${cartItems.length} sepet öğesi bulundu`);

    // ✅ YENİ: Önce set ürünlerini grupla (tek satırda göster)
    const collapsedGroups = collapseSetItems(cartItems);
    log(`${collapsedGroups.size} set grubu tek satıra indirgendi`);

    for (const item of cartItems) {
      // Gizlenmiş item'ları atla
      if (item.classList.contains('set-hidden-item')) continue;

      const handle = getHandleFromItem(item);
      if (!handle) {
        log('Handle bulunamadı, item:', item);
        continue;
      }

      // ✅ YENİ: Bu item'ın rengini tespit et
      const itemColor = extractColorFromItem(item);
      const groupKey = `${handle}_${itemColor}`;

      const group = setGroups.get(groupKey);
      if (!group) {
        log('Grup bulunamadı:', groupKey);
        continue;
      }

      log(`İşleniyor: ${handle} (${itemColor}), Tip: ${group.info.isMultiSize ? 'Multi-size' : group.info.isKatSayi ? 'Kat Sayı' : 'Single'}`);

      if (group.info.isMultiSize) {
        setupMultiSizeControls(item, groupKey, group);
        // Badge artık collapseSetItems içinde ekleniyor
        if (!collapsedGroups.has(groupKey)) {
          addMultiSizeBadge(item, group);
        }
      } else if (group.info.isKatSayi && group.info.multiplier > 0) {
        // ✅ KAT SAYI MODE: İç giyim ürünleri için
        setupKatSayiControls(item, groupKey, group);
        addKatSayiBadge(item, group.info.multiplier);
      } else if (group.info.multiplier > 1) {
        setupSingleVariantControls(item, groupKey, group);
        addSingleVariantBadge(item, group.info.multiplier);
      }
    }

    // Eğer hiç item işlenmediyse, alternatif yöntem dene
    if (cartItems.length === 0) {
      log('Standart seçiciler çalışmadı, alternatif yöntem deneniyor...');
      setTimeout(() => {
        setupAlternativeControls();
      }, 1000);
    }
    setupSetRemoveButtons();

    // ✅ Toplam ağırlığı hesapla ve footer'a yaz
    setTimeout(updateTotalWeight, 500);
  }

  // ✅ YENİ: Footer'da Total Weight elementi oluştur (yoksa)
  function ensureTotalWeightElement() {
    let container = document.getElementById('cart-total-weight');
    if (container) return container;

    // Footer'ı bul
    const footer = document.querySelector('.wt-cart__footer__body, .cart__footer, .wt-cart__drawer__footer');
    if (!footer) {
      log('Footer bulunamadı, Total Weight elementi oluşturulamadı');
      return null;
    }

    // Subtotal'ı bul - onun altına ekleyeceğiz
    const subtotal = footer.querySelector('.wt-cart__subtotal');
    if (!subtotal) {
      log('Subtotal elementi bulunamadı');
      return null;
    }

    // Total Weight elementini oluştur
    container = document.createElement('div');
    container.className = 'wt-cart__subtotal';
    container.id = 'cart-total-weight';
    container.style.display = 'none';
    container.innerHTML = `
      <div class="wt-cart__subtotal__label">
        <span class="text">Total Weight</span>
      </div>
      <div class="wt-cart__subtotal__value">
        <span id="cart-weight-value">--</span>
      </div>
    `;

    // Subtotal'ın hemen altına ekle
    subtotal.insertAdjacentElement('afterend', container);
    log('Total Weight elementi dinamik olarak oluşturuldu');

    return container;
  }

  // ✅ YENİ: Toplam ağırlığı hesapla ve footer'da göster
  async function updateTotalWeight() {
    let totalWeightGrams = 0;
    let hasWeight = false;

    // Her set grubu için ağırlık hesapla
    for (const [groupKey, group] of setGroups) {
      const weightInfo = await fetchProductWeight(group.handle);
      if (!weightInfo || !weightInfo.weight) continue;

      hasWeight = true;
      const unitWeightGrams = toGrams(weightInfo.weight, weightInfo.unit);

      // Toplam adet hesapla
      let totalQuantity = 0;
      if (group.info.isMultiSize) {
        const itemsPerSet = Object.values(group.info.distribution).reduce((a, b) => a + b, 0);
        const setCount = Math.min(...group.items.map(i => Math.floor(i.quantity / (i.expectedQty || 1))));
        totalQuantity = itemsPerSet * setCount;
      } else {
        totalQuantity = group.items[0]?.quantity || 0;
      }

      const groupWeight = unitWeightGrams * totalQuantity;
      totalWeightGrams += groupWeight;
      log(`Weight for ${groupKey}: ${formatWeight(groupWeight)} (${totalQuantity} items × ${formatWeight(unitWeightGrams)})`);
    }

    // Footer'daki total weight elementini al veya oluştur
    const totalWeightContainer = ensureTotalWeightElement();
    const totalWeightValue = document.getElementById('cart-weight-value');

    log('Total weight:', formatWeight(totalWeightGrams), 'hasWeight:', hasWeight);

    if (hasWeight && totalWeightContainer && totalWeightValue) {
      totalWeightValue.textContent = formatWeight(totalWeightGrams);
      totalWeightContainer.style.display = '';
      log('Footer updated with total weight:', formatWeight(totalWeightGrams));
    } else if (totalWeightContainer) {
      totalWeightContainer.style.display = 'none';
    }
  }

  // ✅ YENİ: Sepet item'ından renk bilgisini çıkar
  function extractColorFromItem(itemElement) {
    // ✅ KZK theme: cart-item__variants > dl > div > dt(Renk:) + dd(LACIVERT)
    const dlBlocks = itemElement.querySelectorAll('.cart-item__variants dl > div, .cart-item__variants dl div');
    for (const block of dlBlocks) {
      const dt = block.querySelector('dt');
      const dd = block.querySelector('dd');
      if (dt && dd) {
        const label = (dt.textContent || '').toLowerCase();
        if (label.includes('renk') || label.includes('color') || label.includes('colour')) {
          const colorValue = (dd.textContent || '').trim();
          if (colorValue) {
            log(`DOM'dan renk bulundu (cart-item__variants): ${colorValue}`);
            return colorValue;
          }
        }
      }
    }

    // 1. Önce options'tan renk bilgisini al (eski theme uyumlulugu)
    const optionElements = itemElement.querySelectorAll('.product-option .value');
    for (const optionEl of optionElements) {
      const optionLabel = optionEl.closest('.product-option')?.querySelector('.label')?.textContent || '';
      if (optionLabel.toLowerCase().includes('renk') || optionLabel.toLowerCase().includes('color')) {
        const colorValue = optionEl.textContent.trim();
        log(`DOM'dan renk bulundu (options): ${colorValue}`);
        return colorValue;
      }
    }

    // 2. Variant title'dan renk bilgisi çıkarmayı dene
    const variantInfo = itemElement.querySelector('.variant-title, .cart-item__variant, .product-option');
    if (variantInfo) {
      const text = variantInfo.textContent || '';
      const parts = text.split('/').map(p => p.trim());
      if (parts.length > 0 && parts[0]) {
        log(`DOM'dan renk bulundu (variant): ${parts[0]}`);
        return parts[0];
      }
    }

    log('DOM\'dan renk bulunamadı, default kullanılıyor');
    return 'default'; // Fallback
  }
  
  // Alternatif kontrol kurulumu
  async function setupAlternativeControls() {
    await groupSetItems();
    
    // Tüm quantity input'larını bul
    const allInputs = document.querySelectorAll('input[type="number"], input.quantity__input, input[name*="updates"]');
    
    allInputs.forEach(input => {
      const itemContainer = input.closest('[data-key], [data-cart-item], .cart-item, .cart__item');
      if (itemContainer) {
        const handle = getHandleFromItem(itemContainer);
        if (handle) {
          const itemColor = extractColorFromItem(itemContainer);
          const groupKey = `${handle}_${itemColor}`;
          const group = setGroups.get(groupKey);
          
          if (group && group.info.isMultiSize) {
            log('Alternatif yöntemle bulundu:', groupKey);
            setupMultiSizeControls(itemContainer, groupKey, group);
            addMultiSizeBadge(itemContainer, group);
          }
        }
      }
    });
  }
  
  // ✅ GÜNCELLENDİ: Multi-size set kontrolleri (groupKey ile) - SET SAYISI GİRİLEBİLİR
  function setupMultiSizeControls(item, groupKey, group) {
    // Daha geniş selector'ler
    const quantityInput = item.querySelector('input[name*="updates"], input.quantity__input, input[type="number"], .js-counter-quantity');
    const plusBtn = item.querySelector('[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], button[aria-label*="artır"], .js-counter-increase');
    const minusBtn = item.querySelector('[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"], button[aria-label*="azalt"], .js-counter-decrease');

    if (!quantityInput) {
      log('Quantity input bulunamadı');
      return;
    }

    // Mevcut set sayısını hesapla
    const currentSets = Math.min(
      ...group.items.map(i => Math.floor(i.quantity / i.expectedQty))
    );

    log(`Kontroller ayarlanıyor: groupKey=${groupKey}, currentSets=${currentSets}, Plus: ${!!plusBtn}, Minus: ${!!minusBtn}`);

    // Input'u SET SAYISI olarak ayarla
    quantityInput.setAttribute('data-original-sets', currentSets);
    quantityInput.setAttribute('data-group-key', groupKey);
    quantityInput.setAttribute('data-is-set-input', 'true');
    quantityInput.value = currentSets; // SET SAYISINI GÖSTER
    quantityInput.min = 0;
    quantityInput.step = 1;

    // Plus butonu - tüm event listener'ları temizle ve yenisini ekle
    if (plusBtn) {
      const newPlusBtn = plusBtn.cloneNode(true);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);

      const handlePlus = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const currentVal = parseInt(quantityInput.value) || 0;
        const newVal = currentVal + 1;
        quantityInput.value = newVal;

        log('Plus tıklandı:', groupKey, '-> yeni set sayısı:', newVal);
        await updateMultiSizeSet(groupKey, newVal);
        return false;
      };

      newPlusBtn.addEventListener('click', handlePlus, true);
      newPlusBtn.onclick = handlePlus;
    }

    // Minus butonu
    if (minusBtn) {
      const newMinusBtn = minusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);

      const handleMinus = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const currentVal = parseInt(quantityInput.value) || 0;
        const newVal = Math.max(0, currentVal - 1);
        quantityInput.value = newVal;

        log('Minus tıklandı:', groupKey, '-> yeni set sayısı:', newVal);
        await updateMultiSizeSet(groupKey, newVal);
        return false;
      };

      newMinusBtn.addEventListener('click', handleMinus, true);
      newMinusBtn.onclick = handleMinus;
    }

    // ✅ YENİ: Input'a manuel değer girildiğinde SET SAYISI olarak işle
    const newInput = quantityInput.cloneNode(true);
    quantityInput.parentNode.replaceChild(newInput, quantityInput);

    // Input change event - manuel set sayısı girişi
    const handleInputChange = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const newSets = parseInt(newInput.value) || 0;
      const validSets = Math.max(0, newSets);
      newInput.value = validSets;

      log('Manuel set sayısı girildi:', groupKey, '-> yeni set sayısı:', validSets);
      await updateMultiSizeSet(groupKey, validSets);
    };

    newInput.addEventListener('change', handleInputChange);
    newInput.addEventListener('blur', handleInputChange);

    // Enter tuşu ile de güncelle
    newInput.addEventListener('keypress', async (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        await handleInputChange(e);
      }
    });
  }
  
  // ✅ GÜNCELLENDİ: Tek varyantlı set kontrolleri (groupKey ile)
  function setupSingleVariantControls(item, groupKey, group) {
    const quantityInput = item.querySelector('input[name*="updates"]');
    const plusBtn = item.querySelector('[name="plus"], .quantity__button[name="plus"]');
    const minusBtn = item.querySelector('[name="minus"], .quantity__button[name="minus"]');
    
    if (!quantityInput) return;
    
    const multiplier = group.info.multiplier;
    
    // Mevcut değeri düzelt
    const currentQty = parseInt(quantityInput.value) || 0;
    const roundedQty = Math.round(currentQty / multiplier) * multiplier;
    
    if (currentQty !== roundedQty && roundedQty > 0) {
      quantityInput.value = roundedQty;
      updateSingleItem(quantityInput.name, roundedQty);
    }
    
    // Plus butonu
    if (plusBtn) {
      const newPlusBtn = plusBtn.cloneNode(true);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      
      newPlusBtn.onclick = async (e) => {
        e.preventDefault();
        const current = parseInt(quantityInput.value) || 0;
        const newValue = current + multiplier;
        quantityInput.value = newValue;
        await updateSingleItem(quantityInput.name, newValue);
        showNotification(`+${multiplier} adet (1 set) eklendi`, 'success');
      };
    }
    
    // Minus butonu
    if (minusBtn) {
      const newMinusBtn = minusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
      
      newMinusBtn.onclick = async (e) => {
        e.preventDefault();
        const current = parseInt(quantityInput.value) || 0;
        const newValue = Math.max(0, current - multiplier);
        quantityInput.value = newValue;
        await updateSingleItem(quantityInput.name, newValue);
        if (newValue > 0) {
          showNotification(`-${multiplier} adet (1 set) çıkarıldı`, 'info');
        }
      };
    }
  }
  
  // Tek item güncelleme
  async function updateSingleItem(key, quantity) {
    const id = key.replace('updates[', '').replace(']', '');
    const updates = { [id]: quantity };
    await batchUpdateCart(updates);
  }
  
  // Multi-size badge - Minimal tasarım
  function addMultiSizeBadge(item, group) {
    if (item.querySelector('.multi-size-badge')) return;

    const currentSets = Math.min(
      ...group.items.map(i => Math.floor(i.quantity / i.expectedQty))
    );

    const distribution = Object.entries(group.info.distribution)
      .map(([size, qty]) => `${size}: ${qty * currentSets}`)
      .join(' • ');

    const totalQty = group.items.reduce((sum, i) => sum + i.quantity, 0);

    const badge = document.createElement('div');
    badge.className = 'multi-size-badge';
    badge.style.cssText = `
      background: #f8f9fa;
      color: #333;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 12px;
      margin: 6px 0;
      border: 1px solid #e9ecef;
    `;

    badge.innerHTML = `
      <span style="font-weight: 500;">${currentSets} Set</span>
      ${group.color !== 'default' ? `<span style="opacity: 0.7;"> (${group.color})</span>` : ''}
      <span style="opacity: 0.5;"> • </span>
      <span style="opacity: 0.8; font-size: 11px;">${distribution}</span>
      <span style="opacity: 0.5;"> • </span>
      <span style="opacity: 0.6; font-size: 11px;">${totalQty} adet</span>
    `;

    const priceEl = item.querySelector('.price, .cart-item__price, .cart-item__total');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
    }
  }
  
  // Tek varyant badge - Minimal tasarım
  function addSingleVariantBadge(item, multiplier) {
    if (item.querySelector('.single-variant-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'single-variant-badge';
    badge.style.cssText = `
      background: #f8f9fa;
      color: #333;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 12px;
      margin: 6px 0;
      border: 1px solid #e9ecef;
    `;

    badge.innerHTML = `<span style="font-weight: 500;">Set: ${multiplier} adet</span>`;

    const priceEl = item.querySelector('.price, .cart-item__price, .cart-item__total');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
    }
  }

  // ✅ KAT SAYI: İç giyim ürünleri için kontroller
  function setupKatSayiControls(item, groupKey, group) {
    const quantityInput = item.querySelector('input[name*="updates"]');
    const plusBtn = item.querySelector('[name="plus"], .quantity__button[name="plus"]');
    const minusBtn = item.querySelector('[name="minus"], .quantity__button[name="minus"]');

    if (!quantityInput) return;

    const katSayi = group.info.multiplier;

    // Mevcut değeri kat sayının katına yuvarla (SADECE input.value, cart update YOK)
    // Aksi takdirde sayfa yuklenince her item icin POST atilir -> 422 + 429 rate limit
    // Kullanici +/- bastiginda zaten cart update tetiklenir
    const currentQty = parseInt(quantityInput.value) || 0;
    const roundedQty = Math.ceil(currentQty / katSayi) * katSayi;
    if (currentQty !== roundedQty && roundedQty > 0) {
      quantityInput.value = roundedQty;
    }

    // Step attribute'unu da ayarla (web component'in kendi davranisi icin)
    quantityInput.setAttribute('step', String(katSayi));

    // Cart update'i theme'in <cart-items> handler'ina devret: input.value'yu degistir +
    // 'change' event dispatch et. cart-items.handleChange data-index uzerinden /cart/change.js
    // POST yapar (input name='updates[]' bos oldugu icin updates[ID] parse'i 422 doner).
    const dispatchChange = () => {
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const handlePlus = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const current = parseInt(quantityInput.value) || 0;
      const newValue = current + katSayi;
      quantityInput.value = newValue;
      dispatchChange();
      showNotification(`+${katSayi} adet eklendi`, 'success');
    };

    const handleMinus = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const current = parseInt(quantityInput.value) || 0;
      const newValue = Math.max(0, current - katSayi);
      quantityInput.value = newValue;
      dispatchChange();
      if (newValue > 0) {
        showNotification(`-${katSayi} adet çıkarıldı`, 'info');
      }
    };

    // Input change/blur'da kat sayi katlarina yuvarla (theme handler'i da degeri okur)
    const handleInputChange = () => {
      const val = parseInt(quantityInput.value) || 0;
      const rounded = Math.max(0, Math.round(val / katSayi) * katSayi);
      if (val !== rounded) {
        quantityInput.value = rounded;
        dispatchChange();
      }
    };

    if (plusBtn) {
      const newPlusBtn = plusBtn.cloneNode(true);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      newPlusBtn.addEventListener('click', handlePlus, { capture: true });
    }

    if (minusBtn) {
      const newMinusBtn = minusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
      newMinusBtn.addEventListener('click', handleMinus, { capture: true });
    }

    quantityInput.addEventListener('change', handleInputChange);
    quantityInput.addEventListener('blur', handleInputChange);

    // Web component parent'ina da capture handler bind et (web component'in kendi
    // 'change' event'i input.value'yu Shopify cart update'inden once theme tarafindan
    // round'lanmis halde okusun)
    const quantityInputComponent = item.querySelector('quantity-input');
    if (quantityInputComponent) {
      quantityInputComponent.addEventListener('click', (e) => {
        const target = e.target.closest('button');
        if (!target) return;
        if (target.name === 'plus') { handlePlus(e); }
        else if (target.name === 'minus') { handleMinus(e); }
      }, { capture: true });
    }

    log(`Kat Sayı kontrolleri ayarlandı: ${groupKey}, katSayi=${katSayi}, current=${quantityInput.value}`);
  }

  // ✅ KAT SAYI Badge - Minimal tasarım
  function addKatSayiBadge(item, katSayi) {
    if (item.querySelector('.kat-sayi-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'kat-sayi-badge';
    badge.style.cssText = `
      background: #e8f5e9;
      color: #2e7d32;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 12px;
      margin: 6px 0;
      border: 1px solid #c8e6c9;
    `;

    badge.innerHTML = `<span style="font-weight: 500;">Kat Sayı: ${katSayi}</span> <span style="opacity: 0.7; font-size: 11px;">(${katSayi}'er adet eklenir)</span>`;

    const priceEl = item.querySelector('.price, .cart-item__price, .cart-item__total');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
    }
  }

  function removePriceGroupOption(item) {
    item.querySelectorAll('.options .product-option').forEach(opt => {
      const labelText = opt.querySelector('.label')?.textContent?.trim() || '';
      if (labelText.startsWith('Fiyat Grubu')) {
        opt.remove();
      }
    });
  }
  
  // Handle'ı al
  function getHandleFromItem(item) {
    const link = item.querySelector('a[href*="/products/"]');
    if (link) {
      const url = link.href || link.getAttribute('href');
      const match = url.match(/\/products\/([^?#]+)/);
      if (match) return match[1];
    }
    return null;
  }
  
  // Sepeti yenile
  async function refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
    if (cartDrawer?.refresh) {
      cartDrawer.refresh();
    }
    
    if (window.location.pathname.includes('/cart')) {
      setTimeout(() => window.location.reload(), 500);
    }
    
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
  }
  
  // Mini sepet interceptor
  function interceptMiniCart() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(url, options = {}) {
      if ((url.includes('/cart/change') || url.includes('/cart/update')) && !isUpdating) {

        try {
          const body = options.body;
          let lineKey, requestedQty;

          if (body instanceof FormData) {
            lineKey = body.get('id');
            requestedQty = parseInt(body.get('quantity')) || 0;
          } else if (typeof body === 'string') {
            const json = JSON.parse(body);
            lineKey = json.id;
            requestedQty = json.quantity;
          }

          // Erken exit: lineKey yoksa intercept etmenin anlami yok (cart.js fetch'i atla, rate limit)
          // Bu donus kullanildi: theme'in cart-items.js change handler'i line index (1,2..) gonderir, key yok
          if (!lineKey) {
            return originalFetch.call(this, url, options);
          }

          const cart = await originalFetch('/cart.js').then(r => r.json());
          const cartItem = cart.items.find(i => i.key === lineKey);

          if (cartItem) {
            const handle = cartItem.handle;
            const itemColor = extractColorFromVariant(cartItem);
            const groupKey = `${handle}_${itemColor}`;

            // Erken exit: bu cart item'in groupKey'i set haritasında yoksa overhead atla
            if (!setGroups.has(groupKey)) {
              return originalFetch.call(this, url, options);
            }
            // Multi-size DEGILSE (Kat Sayi vs single) intercept gereksiz: dogrudan fallback
            const groupPeek = setGroups.get(groupKey);
            if (!groupPeek || !groupPeek.info.isMultiSize) {
              return originalFetch.call(this, url, options);
            }

            const group = setGroups.get(groupKey);
            if (group && group.info.isMultiSize) {
              const currentItem = group.items.find(i => i.key === lineKey);
              if (currentItem) {
                const currentSets = Math.floor(cartItem.quantity / currentItem.expectedQty);
                const requestedSets = Math.floor(requestedQty / currentItem.expectedQty);
                
                if (requestedSets > currentSets) {
                  await updateMultiSizeSet(groupKey, 'increase');
                } else if (requestedSets < currentSets) {
                  await updateMultiSizeSet(groupKey, 'decrease');
                }
                
                return new Response(JSON.stringify({ success: true }), { status: 200 });
              }
            }
          }
        } catch (error) {
          log('Mini cart intercept hatası:', error);
        }
      }
      
      return originalFetch.call(this, url, options);
    };
  }
  // Set remove button özelliğini setupCartPageControls fonksiyonunun sonuna ekleyin

// Set remove button işlevselliği - Direkt silme
function setupSetRemoveButtons() {
  const removeButtons = document.querySelectorAll('cart-remove-button, .cart-remove-button, .cart-item__remove, .js-remove-item, a[href*="/cart/change?id="][href*="quantity=0"]');
  
  removeButtons.forEach(button => {
    const removeLink = button.querySelector('a[href="#"]');
    if (!removeLink) return;
    
    const itemContainer = button.closest('[data-cart-item], .cart-item, .cart__item, .wt-cart__item');
    if (!itemContainer) return;
    
    const handle = getHandleFromItem(itemContainer);
    if (!handle) return;
    
    // ✅ YENİ: Renk bilgisini al
    const itemColor = extractColorFromItem(itemContainer);
    const groupKey = `${handle}_${itemColor}`;
    
    const group = setGroups.get(groupKey);
    if (!group) return;
    
    // Eski event listener'ları temizle
    const newRemoveLink = removeLink.cloneNode(true);
    removeLink.parentNode.replaceChild(newRemoveLink, removeLink);
    
    // Yeni remove handler ekle - ONAY OLMADAN DİREKT SİLME
    newRemoveLink.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      log(`Set silme işlemi başlatılıyor: ${groupKey}`);
      
      // ONAY KISMI KALDIRILDI - DİREKT SİLME
      try {
        await removeCompleteSet(groupKey, group);
        showNotification(`${group.info.title} (${group.color}) seti sepetten çıkarıldı`, 'success');
      } catch (error) {
        logError('Set silme hatası:', error);
        showNotification('Set silinirken hata oluştu', 'warning');
      }
      
      return false;
    });
    
    newRemoveLink.onclick = (e) => {
      e.preventDefault();
      return false;
    };
    
    log(`Set remove button ayarlandı: ${groupKey}`);
  });
}

// ✅ GÜNCELLENDİ: Renk bazında set silme
async function removeCompleteSet(groupKey, group) {
  isUpdating = true;
  
  try {
    const updates = {};
    
    if (group.info.isMultiSize) {
      // Multi-size set: tüm bedenleri sıfırla
      for (const item of group.items) {
        updates[item.key] = 0;
        log(`Siliniyor: ${item.size} (${group.color}) - ${item.quantity} adet`);
      }
    } else {
      // Single variant set: ana ürünü sıfırla
      for (const item of group.items) {
        updates[item.key] = 0;
        log(`Siliniyor: Set (${group.color}) - ${item.quantity} adet`);
      }
    }
    
    // Toplu güncelleme ile tüm ürünleri sil
    await batchUpdateCart(updates);
    
    // Set'i cache'den çıkar
    setGroups.delete(groupKey);
    
    log(`Set tamamen silindi: ${groupKey}`);
    
  } finally {
    isUpdating = false;
  }
}

// setupCartPageControls fonksiyonunun sonuna bu satırı ekleyin:
// setupSetRemoveButtons();
  // Bildirim - Minimal tasarım
  function showNotification(message, type = 'info') {
    const existing = document.querySelector('.cart-set-notification');
    if (existing) existing.remove();

    const colors = {
      success: '#28a745',
      info: '#17a2b8',
      warning: '#ffc107'
    };

    const textColors = {
      success: '#fff',
      info: '#fff',
      warning: '#333'
    };

    const notification = document.createElement('div');
    notification.className = 'cart-set-notification';
    notification.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: ${colors[type]};
      color: ${textColors[type]};
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 99999;
      animation: slideIn 0.3s ease-out;
      font-size: 13px;
      max-width: 320px;
    `;

    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(() => notification.remove(), 300);
    }, 2500);
  }
  
  // CSS
  function addStyles() {
    if (document.querySelector('#cart-set-styles')) return;

    const style = document.createElement('style');
    style.id = 'cart-set-styles';
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateY(0); opacity: 1; }
        to { transform: translateY(20px); opacity: 0; }
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .export-spinner {
        animation: spin 1s linear infinite;
      }

      .cart-export-excel-btn:disabled {
        opacity: 0.7;
        cursor: wait !important;
      }

      .multi-size-badge, .single-variant-badge {
        user-select: none;
      }

      input[readonly] {
        background-color: #f3f4f6 !important;
        cursor: not-allowed !important;
      }

      /* Set gruplama stilleri - ÇOK AGRESİF */
      .set-hidden-item,
      li.set-hidden-item,
      div.set-hidden-item,
      .wt-cart__item.set-hidden-item,
      .cart-item.set-hidden-item,
      .cart__item.set-hidden-item,
      li:has(> .set-hidden-item),
      .wt-cart__list > .set-hidden-item {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        max-height: 0 !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        left: -9999px !important;
        top: -9999px !important;
      }

      .set-master-item {
        position: relative;
      }

      .set-collapsed-summary {
        animation: fadeIn 0.2s ease-out;
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      /* Set info badge stilleri - Basit */
      .set-info-badge {
        user-select: none;
      }

      .set-info-badge .value strong {
        font-weight: 600;
      }

      /* Set master item layout düzeltmesi - Agresif Override */
      li.cart-item.wt-cart__item.set-master-item,
      .wt-cart__list li.set-master-item,
      .cart-items li.set-master-item,
      .set-master-item.wt-cart__item,
      .set-master-item.cart-item {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: flex-start !important;
        gap: 15px !important;
        /* Grid override */
        grid-template-columns: none !important;
        grid-template-rows: none !important;
        grid-template-areas: none !important;
      }

      /* Görsel container */
      li.set-master-item > picture,
      li.set-master-item > .wt-cart__item__thumb,
      .set-master-item picture.wt-cart__item__thumb,
      .set-master-item .wt-cart__item__thumb,
      .set-master-item .cart-item__media,
      .set-master-item .cart-item__image {
        flex: 0 0 auto !important;
        flex-shrink: 0 !important;
        width: 100px !important;
        max-width: 100px !important;
        display: block !important;
      }

      /* Body container */
      li.set-master-item > .wt-cart__item__body,
      .set-master-item .wt-cart__item__body,
      .set-master-item .cart-item__details {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        width: auto !important;
        display: block !important;
      }

      /* ✅ KZK: set bozulmasini engelle - hidden item'larda etkilesim yok */
      .set-hidden-item,
      .set-hidden-item * {
        pointer-events: none !important;
      }

      /* Görsel içindeki img */
      .set-master-item .wt-cart__item__thumb img,
      .set-master-item picture img {
        width: 100% !important;
        height: auto !important;
        max-width: 100px !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // Event listeners
  function addEventListeners() {
    document.addEventListener('cart:refresh', () => {
      setTimeout(setupCartPageControls, 500);
    });
    
    document.addEventListener('cart:updated', () => {
      setTimeout(setupCartPageControls, 500);
    });
    
    // Shopify sepet eventleri
    document.addEventListener('cart:change', () => {
      setTimeout(setupCartPageControls, 500);
    });
  }
  
  // DOM observer
  function observeChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList) {
              if (node.classList.contains('cart-item') || 
                  node.classList.contains('cart__item') ||
                  node.querySelector?.('.cart-item')) {
                shouldUpdate = true;
              }
            }
          });
        }
      });
      
      if (shouldUpdate && window.location.pathname.includes('/cart')) {
        setTimeout(setupCartPageControls, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // ============================================
  // EXCEL EXPORT FONKSİYONLARI
  // ============================================

  // ExcelJS kütüphanesini yükle (resim desteği için)
  async function loadExcelJS() {
    if (window.ExcelJS) return window.ExcelJS;

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/exceljs@4.4.0/dist/exceljs.min.js';
      script.onload = () => {
        log('ExcelJS yüklendi');
        resolve(window.ExcelJS);
      };
      script.onerror = () => reject(new Error('ExcelJS yüklenemedi'));
      document.head.appendChild(script);
    });
  }

  // Excel birimleri: kolon genisligi karakter, satir yuksekligi punto, gorsel piksel.
  // px = karakter * 7 + 5   |   px = punto / 0.75
  const IMG_KOLON_KARAKTER = 18;
  const IMG_KOLON_PX = IMG_KOLON_KARAKTER * 7 + 5;
  const IMG_BOSLUK = 4;

  // Görsel URL'sini base64 + gerçek en-boy olarak getir
  async function imageUrlToBase64(url) {
    if (!url) return null;

    try {
      // Shopify CDN'den yeterli cozunurlukte iste. Gorsel Excel'de ~123px
      // genislikte duruyor; 100px kaynak buyutulunce bulaniklasiyordu.
      let optimizedUrl = url;
      if (url.includes('cdn.shopify.com')) {
        optimizedUrl = url.replace(/(_\d+x\d+)?(\.[a-z]+)(\?.*)?$/i, '_400x400$2');
      }

      const response = await fetch(optimizedUrl);
      const blob = await response.blob();

      const dataUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
      if (!dataUrl) return null;

      // Gercek en-boy: Excel'de gorsel ezilmesin diye oran korunur
      const boyut = await new Promise((resolve) => {
        const im = new Image();
        im.onload = () => resolve({ w: im.naturalWidth || 0, h: im.naturalHeight || 0 });
        im.onerror = () => resolve({ w: 0, h: 0 });
        im.src = dataUrl;
      });
      if (!boyut.w || !boyut.h) return null;

      return {
        base64: dataUrl.split(',')[1],
        png: dataUrl.indexOf('image/png') >= 0,
        w: boyut.w,
        h: boyut.h
      };
    } catch (error) {
      log('Görsel yüklenemedi:', url, error);
      return null;
    }
  }

  // Ürün açıklamasından kumaş bilgisini çıkar
  function extractFabricFromDescription(description) {
    if (!description) return '';

    const cleanText = description.replace(/<[^>]*>/g, ' ').replace(/&[a-zA-Z0-9#]+;/g, ' ');

    // "Kumaş:" veya "Fabric:" kalıplarını ara
    const patterns = [
      /Kumaş\s*[:\-]?\s*([^\.]+)/i,
      /Fabric\s*[:\-]?\s*([^\.]+)/i,
      /Material\s*[:\-]?\s*([^\.]+)/i,
      /(\d+%?\s*\w+\s*(?:,\s*\d+%?\s*\w+)*)/i  // "95% Cotton, 5% Elastane" gibi
    ];

    for (const pattern of patterns) {
      const match = cleanText.match(pattern);
      if (match && match[1]) {
        return match[1].trim().substring(0, 100); // Max 100 karakter
      }
    }

    return '';
  }

  // Sepet verilerini topla - Her ürün için sadece 1 satır
  async function collectCartDataForExcel() {
    // Önce setGroups'u güncelle
    await groupSetItems();

    const exportData = [];
    const processedHandles = new Set();

    // 1. Set gruplarını export et - her grup için sadece 1 satır
    for (const [groupKey, group] of setGroups) {
      // Set bilgilerini hesapla
      let itemsPerSet = 0;
      let setCount = 0;
      let totalQty = 0;
      let sizeDistribution = '';
      let unitPrice = 0;
      let totalPrice = 0;
      let fabric = '';
      let productTitle = '';
      let imageUrl = '';
      let barcode = '';

      if (group.info.isMultiSize) {
        itemsPerSet = Object.values(group.info.distribution).reduce((a, b) => a + b, 0);
        setCount = Math.min(...group.items.map(i => Math.floor(i.quantity / (i.expectedQty || 1))));
        totalQty = itemsPerSet * setCount;
        sizeDistribution = Object.entries(group.info.distribution)
          .sort((a, b) => sizeRankCart(a[0]) - sizeRankCart(b[0]))
          .map(([size, qty]) => `${size}:${qty}`)
          .join(' ');

        // Toplam fiyatı hesapla (tüm bedenler dahil)
        for (const item of group.items) {
          totalPrice += (item.price || 0) * item.quantity;
        }
      } else {
        // Set olmayan urun: ayni renkteki butun beden satirlari toplanir ve hangi
        // bedenden kac adet alindigi yazilir (ornek: "85:8 90:12"). Onceden yalnizca
        // ilk satir sayildigi icin diger bedenler adet ve tutara hic girmiyordu.
        totalQty = group.items.reduce((t, i) => t + (Number(i.quantity) || 0), 0);
        setCount = totalQty;
        totalPrice = group.items.reduce((t, i) => t + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0);
        sizeDistribution = group.items
          .map(i => ({ beden: extractSizeFromVariant(i), adet: Number(i.quantity) || 0 }))
          .filter(x => x.beden && x.adet > 0)
          .sort((a, b) => sizeRankCart(a.beden) - sizeRankCart(b.beden))
          .map(x => `${x.beden}:${x.adet}`)
          .join(' ');
      }

      // İlk item'dan bilgileri al
      const firstItem = group.items[0];
      if (firstItem) {
        productTitle = firstItem.product_title || group.info.title || '';
        imageUrl = firstItem.image || '';
        barcode = group.handle.replace(/-r$/, '');
        unitPrice = firstItem.price || 0;
      }

      // Kumaş bilgisi için ürün detaylarını al
      try {
        const productResponse = await fetch(`/products/${group.handle}.js`);
        const product = await productResponse.json();
        fabric = extractFabricFromDescription(product.description);
      } catch (e) {
        log('Ürün detayı alınamadı:', group.handle);
      }

      const isRetail = String(group.handle || '').toLowerCase().endsWith('-r');
      const row = {
        'Product Name': productTitle,
        'Color': group.color !== 'default' ? group.color : '',
        'Set Content': sizeDistribution || '-',
        'Set Qty': setCount,
        'Total Qty': totalQty,
        'Unit Price': (unitPrice / 100).toFixed(2),
        'Total Price': (totalPrice / 100).toFixed(2),
        'Barcode': barcode,
        'EAN': '',
        'Fabric': fabric,
        'Image URL': imageUrl,
        'IsRetail': isRetail
      };

      exportData.push(row);
      processedHandles.add(group.handle);
    }

    // 2. Set olmayan normal ürünleri ekle
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    for (const item of cart.items) {
      const handle = item.handle;
      const itemColor = extractColorFromVariant(item);
      const groupKey = `${handle}_${itemColor}`;

      // Bu item zaten set olarak işlendiyse atla
      if (setGroups.has(groupKey)) continue;

      // Unique key ile tekrarı önle
      const uniqueKey = `${handle}_${item.variant_id}`;
      if (processedHandles.has(uniqueKey)) continue;
      processedHandles.add(uniqueKey);

      // Kumaş bilgisi
      let fabric = '';
      try {
        const productResponse = await fetch(`/products/${handle}.js`);
        const product = await productResponse.json();
        fabric = extractFabricFromDescription(product.description);
      } catch (e) {}

      // Renk + Beden bilgisi (variant_options'tan)
      let color = '';
      let beden = '';
      if (item.options_with_values) {
        const colorOpt = item.options_with_values.find(opt =>
          opt.name.toLowerCase().includes('color') || opt.name.toLowerCase().includes('renk')
        );
        if (colorOpt) color = colorOpt.value;
        const sizeOpt = item.options_with_values.find(opt => {
          const n = opt.name.toLowerCase();
          return n.includes('size') || n.includes('beden') || n.includes('boyut');
        });
        if (sizeOpt) beden = sizeOpt.value;
      }
      // Fallback variant_title'dan ('Renk / Beden' formati)
      if (!beden && item.variant_title) {
        const parts = item.variant_title.split('/').map(s => s.trim());
        if (parts.length >= 2) beden = parts[parts.length - 1];
      }

      const isRetail = String(handle || '').toLowerCase().endsWith('-r');
      const row = {
        'Product Name': item.product_title,
        'Color': color,
        'Set Content': beden ? `${beden}: ${item.quantity}` : '-',
        'Set Qty': '-',
        'Total Qty': item.quantity,
        'Unit Price': (item.price / 100).toFixed(2),
        'Total Price': ((item.price / 100) * item.quantity).toFixed(2),
        'Barcode': handle.replace(/-r$/, ''),
        'EAN': '',
        'Fabric': fabric,
        'Image URL': item.image || '',
        'IsRetail': isRetail
      };

      exportData.push(row);
    }

    return exportData;
  }

  // Excel dosyası oluştur ve indir (ExcelJS ile resim desteği)
  async function exportCartToExcel() {
    const btn = document.querySelector('.cart-export-excel-btn');
    const originalContent = btn ? btn.innerHTML : '';

    // Loading spinner göster
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = `
        <svg class="export-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"></circle>
        </svg>
        Preparing...
      `;
    }

    try {
      // ExcelJS yükle
      const ExcelJS = await loadExcelJS();

      // Verileri topla
      const data = await collectCartDataForExcel();

      if (data.length === 0) {
        showNotification('Sepet boş!', 'warning');
        return;
      }

      // Workbook + Worksheet
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'KZK';
      workbook.created = new Date();
      const worksheet = workbook.addWorksheet('Sepet', {
        views: [{ state: 'frozen', ySplit: 4 }]
      });

      // Stil tanimlari
      const titleFont = { bold: true, size: 18, color: { argb: 'FFFFFFFF' } };
      const titleFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF111827' } };
      const metaFont = { italic: true, size: 11, color: { argb: 'FF6B7280' } };
      const headerFont = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
      const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF374151' } };
      const cellBorder = {
        top: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        left: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        right: { style: 'thin', color: { argb: 'FFE5E7EB' } },
        bottom: { style: 'thin', color: { argb: 'FFE5E7EB' } }
      };
      const totalFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F4F6' } };
      const altRowFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFAFAFA' } };

      // 8 kolon: A=Görsel B=Ürün Adı C=Renk D=Beden Dağılımı E=Adet F=Set Adedi G=Birim H=Toplam
      worksheet.columns = [
        { key: 'image',        width: IMG_KOLON_KARAKTER },
        { key: 'productName',  width: 50 },
        { key: 'color',        width: 18 },
        { key: 'sizeDist',     width: 28 },
        { key: 'totalQty',     width: 10 },
        { key: 'setQty',       width: 10 },
        { key: 'unitPrice',    width: 14 },
        { key: 'totalPrice',   width: 16 }
      ];

      // SATIR 1: BAŞLIK
      worksheet.mergeCells('A1:H1');
      worksheet.getCell('A1').value = 'KEZOKİNO SEPET ÖZETİ';
      worksheet.getCell('A1').font = titleFont;
      worksheet.getCell('A1').fill = titleFill;
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getRow(1).height = 36;

      // SATIR 2: META (tarih + müşteri)
      const metaDate = new Date().toLocaleString('tr-TR');
      const customerEmail = (window.customerData && window.customerData.email) || '';
      worksheet.mergeCells('A2:H2');
      worksheet.getCell('A2').value = customerEmail
        ? `Tarih: ${metaDate}    •    Müşteri: ${customerEmail}`
        : `Tarih: ${metaDate}`;
      worksheet.getCell('A2').font = metaFont;
      worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getRow(2).height = 22;

      // SATIR 3: BOŞ
      worksheet.getRow(3).height = 8;

      // SATIR 4: KOLON BAŞLIKLARI
      const headers = ['Görsel', 'Ürün Adı', 'Renk', 'Beden Dağılımı', 'Adet', 'Set Adedi', 'Birim Fiyat', 'Toplam'];
      headers.forEach((h, i) => {
        const cell = worksheet.getCell(4, i + 1);
        cell.value = h;
        cell.font = headerFont;
        cell.fill = headerFill;
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = cellBorder;
      });
      worksheet.getRow(4).height = 28;

      if (btn) {
        btn.innerHTML = `
          <svg class="export-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"></circle>
          </svg>
          Görseller yükleniyor...
        `;
      }

      // VERİ SATIRLARI
      let dataStartRow = 5;
      let grandQty = 0;
      let grandTotal = 0;

      const fmtRenk = (s) => String(s || '').trim().toLocaleUpperCase('tr-TR');

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        const rowIdx = dataStartRow + i;

        const setQty = (item['Set Qty'] === '-' || item['Set Qty'] == null) ? '' : Number(item['Set Qty']);
        const totalQty = Number(item['Total Qty']) || 0;
        const unitPrice = Number(item['Unit Price']) || 0;
        const totalPrice = Number(item['Total Price']) || 0;

        grandQty += totalQty;
        grandTotal += totalPrice;

        const cells = [
          '',  // A: Görsel (sonra embed)
          item['Product Name'] || '',
          fmtRenk(item['Color']),
          item['Set Content'] === '-' ? 'Tek Beden' : (item['Set Content'] || ''),
          totalQty,
          setQty || '',
          unitPrice,
          totalPrice
        ];

        cells.forEach((v, ci) => {
          const cell = worksheet.getCell(rowIdx, ci + 1);
          cell.border = cellBorder;
          cell.alignment = { vertical: 'middle', wrapText: ci === 1 || ci === 3 };
          if (i % 2 === 1) cell.fill = altRowFill;

          if (ci === 0) cell.alignment.horizontal = 'center';
          else if (ci === 1) cell.alignment.horizontal = 'left';
          else if (ci === 2 || ci === 3) cell.alignment.horizontal = 'left';
          else cell.alignment.horizontal = 'right';

          if (ci === 4 || ci === 5) cell.numFmt = '0';
          if (ci === 6 || ci === 7) cell.numFmt = '#,##0.00 "TL"';

          // B: Urun Adi - retail urunse altina italik mor 'TEKLEME' badge
          if (ci === 1 && item['IsRetail']) {
            cell.value = {
              richText: [
                { font: { size: 11, bold: false, color: { argb: 'FF111827' } }, text: String(v || '') },
                { font: { size: 9, italic: true, bold: true, color: { argb: 'FF7C3AED' } }, text: '\nTEKLEME' }
              ]
            };
          } else if (ci === 1) {
            cell.value = v;
            cell.font = { size: 11 };
          } else {
            cell.value = v;
          }
        });

        // Görsel embed - oran korunur, satir gorsele gore yukselir
        const imageUrl = item['Image URL'];
        let satirYuksekligi = 90;
        if (imageUrl) {
          try {
            const gorsel = await imageUrlToBase64(imageUrl);
            if (gorsel) {
              const genislik = IMG_KOLON_PX - IMG_BOSLUK * 2;
              const yukseklik = Math.round(genislik * gorsel.h / gorsel.w);
              satirYuksekligi = Math.max(90, Math.ceil((yukseklik + IMG_BOSLUK * 2) * 0.75));
              const blokPx = satirYuksekligi / 0.75;
              const ustBosluk = Math.max(IMG_BOSLUK, (blokPx - yukseklik) / 2);
              const imageId = workbook.addImage({
                base64: gorsel.base64,
                extension: gorsel.png ? 'png' : 'jpeg'
              });
              worksheet.addImage(imageId, {
                tl: {
                  col: IMG_BOSLUK / IMG_KOLON_PX,
                  row: rowIdx - 1 + ustBosluk / blokPx
                },
                ext: { width: genislik, height: yukseklik },
                editAs: 'oneCell'
              });
            }
          } catch (imgError) {
            log('Görsel eklenemedi:', imageUrl);
          }
        }
        worksheet.getRow(rowIdx).height = satirYuksekligi;
      }

      // TOPLAM satırı
      const totalRow = dataStartRow + data.length;
      worksheet.mergeCells(totalRow, 1, totalRow, 4);
      const totalLabelCell = worksheet.getCell(totalRow, 1);
      totalLabelCell.value = 'TOPLAM';
      totalLabelCell.font = { bold: true, size: 12 };
      totalLabelCell.fill = totalFill;
      totalLabelCell.alignment = { vertical: 'middle', horizontal: 'right' };
      totalLabelCell.border = cellBorder;

      const totalQtyCell = worksheet.getCell(totalRow, 5);
      totalQtyCell.value = grandQty;
      totalQtyCell.font = { bold: true, size: 12 };
      totalQtyCell.fill = totalFill;
      totalQtyCell.alignment = { vertical: 'middle', horizontal: 'right' };
      totalQtyCell.border = cellBorder;
      totalQtyCell.numFmt = '0';

      worksheet.mergeCells(totalRow, 6, totalRow, 7);
      const blankCell = worksheet.getCell(totalRow, 6);
      blankCell.fill = totalFill;
      blankCell.border = cellBorder;

      const totalPriceCell = worksheet.getCell(totalRow, 8);
      totalPriceCell.value = grandTotal;
      totalPriceCell.font = { bold: true, size: 13, color: { argb: 'FF111827' } };
      totalPriceCell.fill = totalFill;
      totalPriceCell.alignment = { vertical: 'middle', horizontal: 'right' };
      totalPriceCell.border = cellBorder;
      totalPriceCell.numFmt = '#,##0.00 "TL"';
      worksheet.getRow(totalRow).height = 32;

      // Cari iskonto satirlari KALDIRILDI: iskonto tema/ciktilarda GOSTERILMEZ
      // (her musterinin iskontosu farkli; ekran/Excel yan yana kiyaslanabilir).
      // Iskonto siparis olusturulurken backend'de cari'den uygulanip ERP'ye oyle gider.

      // Dosya adı (tarih ile)
      const date = new Date();
      const fileName = `Kezokino_Sepet_${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}_${date.getHours().toString().padStart(2,'0')}${date.getMinutes().toString().padStart(2,'0')}.xlsx`;

      // Excel dosyasını oluştur ve indir
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();

      URL.revokeObjectURL(url);

      showNotification('Excel indirildi!', 'success');
      log('Excel exported:', fileName, data);

    } catch (error) {
      logError('Excel export hatası:', error);
      showNotification('Excel indirilemedi!', 'warning');
    } finally {
      // Butonu eski haline döndür
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalContent;
      }
    }
  }

  // Sepeti tumuyle bosaltma butonu (Excel butonunun yanina)
  function addClearCartButton() {
    if (document.querySelector('.cart-clear-btn')) return;

    const cartHeader = document.querySelector('.wt-cart__header, .cart__header, .cart-header');
    if (!cartHeader) {
      log('Cart header bulunamadı, sepeti boşalt butonu eklenemedi');
      return;
    }

    const btn = document.createElement('button');
    btn.className = 'cart-clear-btn';
    btn.type = 'button';
    btn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
        <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
      </svg>
      Sepeti Boşalt
    `;

    btn.style.cssText = `
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
      background: #ffffff;
      color: #b91c1c;
      border: 1px solid #fca5a5;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      margin-left: 10px;
      transition: background 0.2s, border-color 0.2s;
    `;
    btn.addEventListener('mouseenter', () => {
      btn.style.background = '#fef2f2';
      btn.style.borderColor = '#f87171';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.background = '#ffffff';
      btn.style.borderColor = '#fca5a5';
    });

    btn.addEventListener('click', async () => {
      let adet = 0;
      try {
        const sepet = await fetch('/cart.js').then(r => r.json());
        adet = sepet.item_count || 0;
      } catch (e) {
        log('Sepet okunamadı:', e);
      }
      if (!adet) {
        alert('Sepetiniz zaten boş.');
        return;
      }
      if (!confirm(`Sepetteki ${adet} adet ürünün tamamı silinecek. Onaylıyor musunuz?`)) return;

      const eskiIcerik = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Boşaltılıyor...';
      try {
        const r = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        if (!r.ok) throw new Error('sunucu ' + r.status);
        window.location.reload();
      } catch (e) {
        btn.disabled = false;
        btn.innerHTML = eskiIcerik;
        alert('Sepet boşaltılamadı: ' + e.message);
      }
    });

    const headerAction = cartHeader.querySelector('.wt-cart__header__action');
    if (headerAction) {
      headerAction.appendChild(btn);
    } else {
      cartHeader.appendChild(btn);
    }

    log('Sepeti boşalt butonu eklendi');
  }

  // Export butonunu sepet sayfasına ekle
  function addExportButton() {
    // Zaten varsa ekleme
    if (document.querySelector('.cart-export-excel-btn')) return;

    // Sepet header'ını bul
    const cartHeader = document.querySelector('.wt-cart__header, .cart__header, .cart-header');
    if (!cartHeader) {
      log('Cart header bulunamadı, export butonu eklenemedi');
      return;
    }

    // Buton oluştur
    const btn = document.createElement('button');
    btn.className = 'cart-export-excel-btn';
    btn.type = 'button';
    btn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      Excel İndir
    `;

    btn.addEventListener('click', exportCartToExcel);

    // Stiller
    btn.style.cssText = `
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
      background: #217346;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      margin-left: 15px;
      transition: background 0.2s;
    `;

    btn.addEventListener('mouseenter', () => btn.style.background = '#1a5c38');
    btn.addEventListener('mouseleave', () => btn.style.background = '#217346');

    // Header'a ekle
    const headerAction = cartHeader.querySelector('.wt-cart__header__action');
    if (headerAction) {
      headerAction.appendChild(btn);
    } else {
      cartHeader.appendChild(btn);
    }

    log('Export Excel butonu eklendi');
  }

  // Ana başlatma
  async function init() {
    log('Cart Set Multiplier başlatılıyor...');
    
    // quantity-multiplier.js'nin sepette çalışmasını engelle
    if (window.location.pathname.includes('/cart')) {
      // window.productVariantInfo'yu temizle ki quantity-multiplier.js çalışmasın
      if (window.productVariantInfo) {
        delete window.productVariantInfo;
      }
    }
    
    addStyles();
    interceptMiniCart();
    
    // Sepet sayfasındaysak kontrolleri kur
    if (window.location.pathname.includes('/cart')) {
      await setupCartPageControls();
      addExportButton(); // Excel export butonu ekle
      addClearCartButton(); // Sepeti bosalt butonu ekle
    }

    addEventListeners();
    observeChanges();
    
    log('Cart Set Multiplier hazır! Set grupları:', setGroups);
  }
  
  // DOM hazır olduğunda başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();